
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jhcFr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


const $d8b18ba521bd2fb8$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("bvAE7")));
const $d8b18ba521bd2fb8$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $d8b18ba521bd2fb8$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $d8b18ba521bd2fb8$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $d8b18ba521bd2fb8$export$5057fa778edd8de9 = (props, config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const WrapperComponent = (0, $42omo.useMemo)(()=>(props)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($d8b18ba521bd2fb8$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props,
                config: config
            });
        }, [
        config
    ]);
    return (0, $42omo.useMemo)(()=>{
        return {
            ...props ?? {},
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: $d8b18ba521bd2fb8$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props
    ]);
};
module.exports["useLinkPickerEditorProps"] = $d8b18ba521bd2fb8$export$5057fa778edd8de9;

});

parcelRegister("bvAE7", function(module, exports) {

let $860f041774b7fa35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $860f041774b7fa35$var$load("bGpE6"),
    $860f041774b7fa35$var$load("6wr18"),
    $860f041774b7fa35$var$load("4RbVd"),
    $860f041774b7fa35$var$load("jg5LT"),
    $860f041774b7fa35$var$load("9wzNh"),
    $860f041774b7fa35$var$load("ffEVr"),
    $860f041774b7fa35$var$load("7f9Fz"),
    $860f041774b7fa35$var$load("9ldRJ"),
    $860f041774b7fa35$var$load("6iF9L")
]).then(()=>parcelRequire('hyBPw'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("agrUc", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3RxtY = parcelRequire("3RxtY");


var $3pLGZ = parcelRequire("3pLGZ");


var $16GCc = parcelRequire("16GCc");


var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");


var $dh538 = parcelRequire("dh538");


var $aGTRk = parcelRequire("aGTRk");


var $24P9d = parcelRequire("24P9d");




const $c63be1b8be1ad0fa$export$f664dd11022c8749 = ()=>{
    const blockCardNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $aGTRk.blockCardWithLocalId) : (0, $aGTRk.blockCard);
    return {
        ...blockCardNode,
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap',
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $24P9d.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};


/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $cfHGv = parcelRequire("cfHGv");





var $aFUXX = parcelRequire("aFUXX");




// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $f774c65213d94fad$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $f774c65213d94fad$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $f774c65213d94fad$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $f774c65213d94fad$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $f774c65213d94fad$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $f774c65213d94fad$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $f774c65213d94fad$var$LINE_LENGTH = 760;
const $f774c65213d94fad$export$f8faabd3267a007e = ()=>{
    const embedCardNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $cfHGv.embedCardWithLocalId) : (0, $cfHGv.embedCard);
    return {
        ...embedCardNode,
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) / (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $24P9d.convertToInlineCss)({
                    margin: $f774c65213d94fad$var$calcMargin(layout),
                    width: `${Math.ceil($f774c65213d94fad$var$calcPxFromPct(width / 100, $f774c65213d94fad$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $f774c65213d94fad$var$float(layout)
                }),
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $24P9d.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $24P9d.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};



var $aqHdD = parcelRequire("aqHdD");







const $5e2feeed1fe88326$export$290edac762b9f37c = ()=>{
    const inlineCardNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $aqHdD.inlineCardWithLocalId) : (0, $aqHdD.inlineCard);
    return {
        ...inlineCardNode,
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $24P9d.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-radius-small, 4px)",
                    color: "var(--ds-link, #1868DB)",
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                }),
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};



var $9AGwg = parcelRequire("9AGwg");


var $btzjy = parcelRequire("btzjy");


var $d7ZU3 = parcelRequire("d7ZU3");


var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $1oCLl = parcelRequire("1oCLl");

const $c11f6b33b827655c$var$lookupPixel = 10;
const $c11f6b33b827655c$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $8m4tT.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $c11f6b33b827655c$var$lookupPixel : coord.bottom + $c11f6b33b827655c$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $8m4tT.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $c11f6b33b827655c$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $c11f6b33b827655c$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $ks2lK.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $c11f6b33b827655c$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if (browser.chrome && browser.chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveUp).common, $c11f6b33b827655c$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveDown).common, $c11f6b33b827655c$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $dus6D.keymap)(list);
}



var $2P8Ax = parcelRequire("2P8Ax");


var $bT1qC = parcelRequire("bT1qC");


var $1S4f7 = parcelRequire("1S4f7");


var $0vvte = parcelRequire("0vvte");








var $hBNGD = parcelRequire("hBNGD");


var $4enQ2 = parcelRequire("4enQ2");


var $ftpVl = parcelRequire("ftpVl");


var $iu6m9 = parcelRequire("iu6m9");


var $6JHzw = parcelRequire("6JHzw");


const $2e63a2a02cf8ecda$export$7da1e5b9c509a0c1 = (props)=>{
    const { isPageSSRed: isPageSSRed } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed) return (0, $6JHzw.blockCardNodeView)(props);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'blockCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("6JHzw"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                return blockCardNodeView(props);
            });
            return result;
        }
    });
};









var $7IyZf = parcelRequire("7IyZf");


const $96a8f130dedf8a71$export$eb946eb841dd1469 = (props)=>{
    const { isPageSSRed: isPageSSRed } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed) return (0, $7IyZf.embedCardNodeView)(props);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'embedCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("7IyZf"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                return embedCardNodeView(props);
            });
            return result;
        }
    });
};















const $db3cf41c83217b98$export$cd3f6a9b84ab8435 = (props)=>{
    const { isPageSSRed: isPageSSRed = false } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false) || (0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) || isPageSSRed) return (0, $4enQ2.inlineCardNodeView)(props);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'inlineCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("4enQ2"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                return inlineCardNodeView(props);
            });
            return result;
        }
    });
};



var $8EkET = parcelRequire("8EkET");


var $cCTpf = parcelRequire("cCTpf");


var $d925B = parcelRequire("d925B");


var $doRn8 = parcelRequire("doRn8");


var $7iE7T = parcelRequire("7iE7T");

var $l9G9n = parcelRequire("l9G9n");


var $aXG5V = parcelRequire("aXG5V");


var $6SJAP = parcelRequire("6SJAP");


var $22wcR = parcelRequire("22wcR");


var $h92Fd = parcelRequire("h92Fd");


var $5YZhQ = parcelRequire("5YZhQ");

const $4dddc73ca76bf0aa$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $4dddc73ca76bf0aa$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $4dddc73ca76bf0aa$var$isTransactionResolveReplace(tr);
    const isAutoConvert = $4dddc73ca76bf0aa$var$isAutoConvertTr(tr);
    // History
    const historyMeta = tr.getMeta((0, $l9G9n.pmHistoryPluginKey));
    const isUndo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $4dddc73ca76bf0aa$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $aXG5V.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $7iE7T.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $5YZhQ.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $aXG5V.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $7iE7T.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $5YZhQ.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $5YZhQ.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $5YZhQ.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $5YZhQ.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $5YZhQ.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $4dddc73ca76bf0aa$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet.
		 * Also skip when the transaction is an auto-convert
		 * (e.g. a pasted link being converted to a native embed extension),
		 * because the link is being converted, not deleted by the user.
		 */ if (!isResolveReplace && !isAutoConvert) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $4dddc73ca76bf0aa$var$getResolvePositions(tr, state);
        inserted.push(...(0, $5YZhQ.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $doRn8.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $5YZhQ.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $4dddc73ca76bf0aa$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $5YZhQ.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $5YZhQ.getNodeSubject)(inserted[i].node);
            if ($4dddc73ca76bf0aa$var$isDatasourceUpgrade(previousSubject, currentSubject) || $4dddc73ca76bf0aa$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $4dddc73ca76bf0aa$var$UPDATE_ACTIONS = [
    (0, $d925B.ACTION).CHANGED_TYPE,
    (0, $d925B.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $4dddc73ca76bf0aa$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $8EkET.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $4dddc73ca76bf0aa$var$UPDATE_ACTIONS.includes(action);
    });
};
const $4dddc73ca76bf0aa$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $4dddc73ca76bf0aa$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    return $4dddc73ca76bf0aa$var$isMetadataQueue(pluginMeta);
};
const $4dddc73ca76bf0aa$var$isMetadataQueue = (metaData)=>{
    return $4dddc73ca76bf0aa$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $4dddc73ca76bf0aa$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    return $4dddc73ca76bf0aa$var$isMetadataResolve(pluginMeta);
};
/**
 * Checks if the transaction is an auto-convert action
 * (e.g. a pasted link being converted to a native embed extension node).
 * In this case the link removal should not be tracked as a deletion.
 */ const $4dddc73ca76bf0aa$var$isAutoConvertTr = (tr)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $8EkET.LinkMetaStep))) return false;
        return step.getMetadata().cardAction === 'AUTO_CONVERT';
    });
};
const $4dddc73ca76bf0aa$var$isMetadataResolve = (metaData)=>{
    return $4dddc73ca76bf0aa$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $4dddc73ca76bf0aa$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $4dddc73ca76bf0aa$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    if (!$4dddc73ca76bf0aa$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $4dddc73ca76bf0aa$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $22wcR.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    if (!$4dddc73ca76bf0aa$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $4dddc73ca76bf0aa$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $22wcR.getPluginState)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $4dddc73ca76bf0aa$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $h92Fd.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $h92Fd.EVENT_SUBJECT).LINK;
const $4dddc73ca76bf0aa$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $h92Fd.EVENT_SUBJECT).LINK && currentSubject === (0, $h92Fd.EVENT_SUBJECT).DATASOURCE;
function $4dddc73ca76bf0aa$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $cCTpf.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $l9G9n.pmHistoryPluginKey));
        const isUndo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $doRn8.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $4dddc73ca76bf0aa$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $5YZhQ.getNodeSubject)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $5YZhQ.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $h92Fd.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $5YZhQ.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $h92Fd.EVENT).DELETED);
        pushEvents(inserted, (0, $h92Fd.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}






var $hrFA1 = parcelRequire("hrFA1");

const $63afa27de13e413f$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];


const $6d7703230e08f307$export$32844f9f273856e4 = (editorView)=>{
    if (editorView) {
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $8m4tT.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, $hrFA1.isDatasourceNode)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
    }
    return {
        node: undefined,
        pos: undefined
    };
};
const $6d7703230e08f307$export$8467cbb601c13bfc = (layout)=>{
    return (0, $63afa27de13e413f$export$3f155c85880510c8).some((l)=>l === layout);
};



var $5v798 = parcelRequire("5v798");







const $a2739f0c627e4901$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $a2739f0c627e4901$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $a2739f0c627e4901$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $a2739f0c627e4901$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $a2739f0c627e4901$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $a2739f0c627e4901$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $a2739f0c627e4901$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $a2739f0c627e4901$var$setResolvedToolbarAttributes = (state, action)=>{
    return {
        ...state,
        resolvedToolbarAttributesByUrl: {
            ...state.resolvedToolbarAttributesByUrl,
            [action.url]: action.attributes
        }
    };
};
const $a2739f0c627e4901$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $a2739f0c627e4901$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $a2739f0c627e4901$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $a2739f0c627e4901$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $a2739f0c627e4901$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $a2739f0c627e4901$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $a2739f0c627e4901$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $a2739f0c627e4901$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $a2739f0c627e4901$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $a2739f0c627e4901$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $a2739f0c627e4901$var$queue(state, action);
        case 'SET_PROVIDER':
            return $a2739f0c627e4901$var$setProvider(state, action);
        case 'RESOLVE':
            return $a2739f0c627e4901$var$resolve(state, action);
        case 'REGISTER':
            return $a2739f0c627e4901$var$register(state, action);
        case 'REMOVE_CARD':
            return $a2739f0c627e4901$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $a2739f0c627e4901$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $a2739f0c627e4901$var$setDatasourceTableRef(state, action);
        case 'SET_RESOLVED_TOOLBAR_ATTRIBUTES':
            return $a2739f0c627e4901$var$setResolvedToolbarAttributes(state, action);
        case 'SET_CARD_LAYOUT':
            return $a2739f0c627e4901$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $a2739f0c627e4901$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $a2739f0c627e4901$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $a2739f0c627e4901$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $a2739f0c627e4901$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $a2739f0c627e4901$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $a2739f0c627e4901$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $a2739f0c627e4901$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $a2739f0c627e4901$var$removeDatasourceStash(state, action);
    }
};













const $61e05dab6ab021e0$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $l9G9n.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $61e05dab6ab021e0$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>{
    const isEmbedFriendlyLocation = $61e05dab6ab021e0$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($61e05dab6ab021e0$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer), $61e05dab6ab021e0$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $61e05dab6ab021e0$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $16GCc.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $61e05dab6ab021e0$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer)=>(resolvedCard)=>{
        $61e05dab6ab021e0$var$updateCardType(resolvedCard, options);
        (0, $btzjy.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)(view.state, view.dispatch);
        return resolvedCard;
    };
const $61e05dab6ab021e0$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $btzjy.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $61e05dab6ab021e0$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $9AGwg.setProvider)(cardProvider)(state.tr));
    });
};








const $3bd04be2ce29553e$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
const $3bd04be2ce29553e$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $22wcR.getPluginState)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $9AGwg.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $3bd04be2ce29553e$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, embedCardTransformers: embedCardTransformers } = options;
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $bT1qC.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $4enQ2.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                CompetitorPrompt: CompetitorPrompt
            }
        });
        return new (0, $1S4f7.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        resolvedToolbarAttributesByUrl: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        embedCardTransformers: embedCardTransformers,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $22wcR.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $6SJAP.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $4dddc73ca76bf0aa$export$c985b35883eaea59)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $ks2lK.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    if (!enableInlineUpgradeFeatures) return (0, $a2739f0c627e4901$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    const newState = (0, $a2739f0c627e4901$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $5v798.isLocalStorageKeyDiscovered)($3bd04be2ce29553e$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $hrFA1.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $hrFA1.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $61e05dab6ab021e0$export$96766f42428c9e7f)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $22wcR.getPluginState)(view.state);
                        const oldState = (0, $22wcR.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $ks2lK.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $8m4tT.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $0vvte.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $6d7703230e08f307$export$8467cbb601c13bfc)(node.attrs.layout) ? node.attrs.layout : (0, $hBNGD.DATASOURCE_DEFAULT_LAYOUT);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $9AGwg.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $9AGwg.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $22wcR.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $2P8Ax.default)(()=>(0, $61e05dab6ab021e0$export$2007d0af08977743)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined, currentState?.embedCardTransformers?.embedCardNodeTransformer));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $db3cf41c83217b98$export$cd3f6a9b84ab8435)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $2e63a2a02cf8ecda$export$7da1e5b9c509a0c1)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: options.CompetitorPrompt
                    }),
                    embedCard: (0, $96a8f130dedf8a71$export$eb946eb841dd1469)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: options.CompetitorPrompt
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $3bd04be2ce29553e$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $3bd04be2ce29553e$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $6SJAP.pluginKey)
        });
    };








const $c083b4a75648c16a$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};






var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");






var $iB8ko = parcelRequire("iB8ko");


var $eIleF = parcelRequire("eIleF");


var $dQwlz = parcelRequire("dQwlz");

















var $8dcLZ = parcelRequire("8dcLZ");

const $4cc15576004509ff$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $4cc15576004509ff$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $42omo.useCallback)(()=>{
        dispatch((0, $9AGwg.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $4cc15576004509ff$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $4cc15576004509ff$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $4cc15576004509ff$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $42omo.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $btzjy.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $btzjy.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $4cc15576004509ff$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $ks2lK.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $4cc15576004509ff$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};


const $7be576037a301bd0$var$selector = (states)=>{
    return {
        showDatasourceModal: states.cardState?.showDatasourceModal,
        datasourceModalType: states.cardState?.datasourceModalType
    };
};
const $7be576037a301bd0$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $7be576037a301bd0$var$selector);
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $7be576037a301bd0$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dQwlz.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4cc15576004509ff$export$95702e90d329951a), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $7be576037a301bd0$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.EditorSmartCardProviderValueGuard), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($7be576037a301bd0$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $7be576037a301bd0$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $iB8ko.default),
        datasourceId: (0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $jPEjP.default),
        datasourceId: (0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $bEi27.default),
        datasourceId: (0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $7be576037a301bd0$export$2e2bcd8739ae039 = $7be576037a301bd0$var$SafeModalWithState;















var $aJdNi = parcelRequire("aJdNi");





var $6v6KC = parcelRequire("6v6KC");


var $7pxpu = parcelRequire("7pxpu");










/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $6aa09a6deac4dd46$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $6aa09a6deac4dd46$export$8793fab959da70d1 = $6aa09a6deac4dd46$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $d925B.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $d925B.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $d925B.INPUT_METHOD).AUTO_DETECT:
        case (0, $d925B.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $d925B.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $d925B.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $d925B.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $6aa09a6deac4dd46$export$df2aa842dc5172b0 = $6aa09a6deac4dd46$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $d925B.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $d925B.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $6aa09a6deac4dd46$export$1cf3d8365b174bde = $6aa09a6deac4dd46$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $d925B.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $6aa09a6deac4dd46$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $6v6KC.default) ? metadata.sourceEvent : null;
};


function $4601a5dc005fe120$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $4601a5dc005fe120$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $4601a5dc005fe120$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $6v6KC.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $4601a5dc005fe120$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $4601a5dc005fe120$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $6v6KC.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $4601a5dc005fe120$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $4601a5dc005fe120$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $4601a5dc005fe120$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $7pxpu.useDatasourceLifecycleAnalytics)();
    const eventHandlers = (0, $42omo.useMemo)(()=>{
        return {
            [(0, $h92Fd.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $4601a5dc005fe120$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $h92Fd.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $4601a5dc005fe120$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $h92Fd.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $4601a5dc005fe120$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
	 * Subscribe to datasource events
	 */ (0, $42omo.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $h92Fd.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};















/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $19091767794a90ac$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $19091767794a90ac$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
	 * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
	 * to defer any heavy operations involving network
	 *
	 * The callbacks themselves should not be deferred, they should be called syncronously the moment
	 * the events take place.
	 */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $7pxpu.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $42omo.useMemo)(()=>{
        return {
            [(0, $h92Fd.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $5YZhQ.getUrl)(node);
                if (!url) return;
                const display = (0, $5YZhQ.appearanceForLink)(node);
                const displayCategory = $19091767794a90ac$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $6aa09a6deac4dd46$export$b3b4df0d75d4c011)(metadata);
                const creationMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $h92Fd.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $5YZhQ.getUrl)(node);
                if (!url) return;
                const display = (0, $5YZhQ.appearanceForLink)(node);
                const displayCategory = $19091767794a90ac$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $6aa09a6deac4dd46$export$b3b4df0d75d4c011)(metadata);
                const updateMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata);
                const updateType = (0, $6aa09a6deac4dd46$export$df2aa842dc5172b0)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $h92Fd.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $5YZhQ.getUrl)(node);
                if (!url) return;
                const display = (0, $5YZhQ.appearanceForLink)(node);
                const displayCategory = $19091767794a90ac$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $6aa09a6deac4dd46$export$b3b4df0d75d4c011)(metadata);
                const deleteMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata);
                const deleteType = (0, $6aa09a6deac4dd46$export$1cf3d8365b174bde)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
	 * Subscribe to link events
	 */ (0, $42omo.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $h92Fd.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};


class $1e937672f72cb9a7$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !this.props.editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.EditorSmartCardProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.EditorSmartCardProviderValueGuard), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aJdNi.EditorAnalyticsContext), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $19091767794a90ac$export$aa142efb89c75ed5), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4601a5dc005fe120$export$bddcbec746c26287), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}






var $dLAsE = parcelRequire("dLAsE");







const $881bfe26507459bc$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $dLAsE.useSmartLinkEvents)();
    (0, $42omo.useEffect)(()=>{
        if (!events || (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
        editorView.dispatch((0, $9AGwg.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $cs1vW = parcelRequire("cs1vW");





var $jwWgu = parcelRequire("jwWgu");


var $a4eZN = parcelRequire("a4eZN");


var $fJNzZ = parcelRequire("fJNzZ");


var $1kVeP = parcelRequire("1kVeP");


var $64M9v = parcelRequire("64M9v");











const $3de0a05ef0adcbab$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    background: `${"var(--ds-background-neutral, #0515240F)"}`,
    color: `${"var(--ds-icon, #292A2E)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, #292A2E)"} !important`
    }
});
const $3de0a05ef0adcbab$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $hBNGD.DATASOURCE_DEFAULT_LAYOUT), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $fJNzZ.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $42omo.useMemo)(()=>{
        return formatMessage((0, $fJNzZ.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        testId: testId,
        css: $3de0a05ef0adcbab$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
            label: title
        }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
            label: title
        })
    }));
};
const $3de0a05ef0adcbab$var$selector = (states)=>{
    return {
        layout: states.cardState?.layout,
        datasourceTableRef: states.cardState?.datasourceTableRef
    };
};
const $3de0a05ef0adcbab$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { node: node, pos: pos } = (0, $6d7703230e08f307$export$32844f9f273856e4)(editorView);
    const { layout: layout = node?.attrs?.layout || undefined, datasourceTableRef: datasourceTableRef } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $3de0a05ef0adcbab$var$selector);
    const isDatasource = (0, $hrFA1.isDatasourceNode)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $6d7703230e08f307$export$32844f9f273856e4)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $9AGwg.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3de0a05ef0adcbab$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $6d7703230e08f307$export$8467cbb601c13bfc)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
const $3de0a05ef0adcbab$var$_default_1 = (0, $cs1vW.default)($3de0a05ef0adcbab$var$LayoutButtonWrapper);
var $3de0a05ef0adcbab$export$2e2bcd8739ae039 = $3de0a05ef0adcbab$var$_default_1;



var $9Rg2N = parcelRequire("9Rg2N");

const $10220c45d3a290e4$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $c083b4a75648c16a$export$5115a388c364848d)();
    let instanceEmbedCardTransformers = options.embedCardTransformers;
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $6SJAP.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $5e2feeed1fe88326$export$290edac762b9f37c)()
                },
                {
                    name: 'blockCard',
                    node: (0, $c63be1b8be1ad0fa$export$f664dd11022c8749)()
                }
            ];
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $f774c65213d94fad$export$f8faabd3267a007e)()
            });
            return nodes;
        },
        pmPlugins () {
            const allowBlockCards = options.allowBlockCards ?? true;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $3bd04be2ce29553e$export$ae829ec7b2625219)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        embedCardTransformers: instanceEmbedCardTransformers,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $c11f6b33b827655c$export$fc7a7a088775f35d)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $881bfe26507459bc$export$e7d7ea2bc9a806d9), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1e937672f72cb9a7$export$c083a9ed3df8f5ac), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $3de0a05ef0adcbab$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7be576037a301bd0$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $9AGwg.setProvider)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $9AGwg.hideLinkToolbar,
            queueCardsFromChangedTr: $btzjy.queueCardsFromChangedTr,
            registerEmbedCardTransformer: (transformers)=>{
                instanceEmbedCardTransformers = transformers;
            },
            getStartingToolbarItems: (0, $9Rg2N.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $9Rg2N.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $9Rg2N.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertArray = [];
                if (!options.allowDatasource) return quickInsertArray;
                quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $3RxtY.messages).datasourceJiraIssueIssueTermRefresh : (0, $3RxtY.messages).datasourceJiraIssue),
                    description: formatMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $3RxtY.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $3RxtY.messages).datasourceJiraIssueDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'jira'
                    ],
                    featured: true,
                    ...(0, $dh538.fg)('jim-lower-ranking-in-jira-macro-search') && {
                        priority: 500
                    },
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDatasourceJiraIssue), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $9AGwg.showDatasourceModal)('jira')(tr);
                        return tr;
                    }
                });
                if ((0, $16GCc.canRenderDatasource)((0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $3RxtY.messages).datasourceAssetsObjectsGeneralAvailability),
                    description: formatMessage((0, $3RxtY.messages).datasourceAssetsObjectsDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'assets'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDatasourceAssetsObjects), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $9AGwg.showDatasourceModal)('assets')(tr);
                        return tr;
                    }
                });
                if ((0, $hrFA1.isDatasourceConfigEditable)((0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $3RxtY.messages).datasourceConfluenceSearch),
                    description: formatMessage((0, $3RxtY.messages).datasourceConfluenceSearchDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'confluence'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDatasourceConfluenceSearch), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $9AGwg.showDatasourceModal)('confluence-search')(tr);
                        return tr;
                    }
                });
                return quickInsertArray;
            }
        }
    };
};
module.exports["cardPlugin"] = $10220c45d3a290e4$export$2a6748328f902e16;

});

parcelRegister("eKaDU", function(module, exports) {
var $5234cdfb9b29e9d1$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $5234cdfb9b29e9d1$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});
module.exports["LAYOUT_TYPE"] = $5234cdfb9b29e9d1$export$9710eda883ce7be2;
module.exports["SMART_LINK_TYPE"] = $5234cdfb9b29e9d1$export$804a928ffc86c02c;

});

parcelRegister("4enQ2", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2P8Ax = parcelRequire("2P8Ax");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $7YjFd = parcelRequire("7YjFd");

var $gndLe = parcelRequire("gndLe");


var $f9yl5 = parcelRequire("f9yl5");


var $hpUsb = parcelRequire("hpUsb");


var $9CM6e = parcelRequire("9CM6e");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $9AGwg = parcelRequire("9AGwg");


var $hrFA1 = parcelRequire("hrFA1");


var $9Rg2N = parcelRequire("9Rg2N");


var $cOfDZ = parcelRequire("cOfDZ");














var $7FiWH = parcelRequire("7FiWH");


var $ks2lK = parcelRequire("ks2lK");


var $79vw2 = parcelRequire("79vw2");


var $7ee1w = parcelRequire("7ee1w");


var $226XV = parcelRequire("226XV");











var $6SJAP = parcelRequire("6SJAP");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $bYRk6 = parcelRequire("bYRk6");











var $5v798 = parcelRequire("5v798");

const $19cfbef4ec1a2073$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $42omo.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $42omo.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $42omo.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $42omo.useMemo)(()=>isPulseEnabled && !(0, $5v798.isLocalStorageKeyDiscovered)((0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $19cfbef4ec1a2073$export$2e2bcd8739ae039 = $19cfbef4ec1a2073$var$useLinkUpgradeDiscoverability;


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $jSnXV = parcelRequire("jSnXV");


var $1cfRh = parcelRequire("1cfRh");


var $3RxtY = parcelRequire("3RxtY");


var $TfRUG = parcelRequire("TfRUG");


var $isYda = parcelRequire("isYda");

const $5a27629e4ec16f4d$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
const $5a27629e4ec16f4d$export$ce3ffcce447cf028 = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().left;
    const end = endEl.getBoundingClientRect().left;
    return end - start;
};
const $5a27629e4ec16f4d$export$be02a7fcf666d65d = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().top;
    const end = endEl.getBoundingClientRect().top;
    return start === end;
};
const $5a27629e4ec16f4d$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
    const max = overlayEl.getBoundingClientRect().width;
    const min = max - labelEl.getBoundingClientRect().width;
    return {
        max: max,
        min: min
    };
};
const $5a27629e4ec16f4d$export$3eb7d6130acfda37 = (labelEl)=>{
    const h2FontSizePx = 20;
    const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
    if (!fontSize || fontSize < h2FontSizePx) return 'small';
    return 'medium';
};


function $c2c8d7917d524ff5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c2c8d7917d524ff5$var$DEBOUNCE_IN_MS = 5;
const $c2c8d7917d524ff5$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
const $c2c8d7917d524ff5$var$PADDING_IN_PX = 4;
const $c2c8d7917d524ff5$var$ICON_WIDTH_IN_PX = 14;
const $c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
const $c2c8d7917d524ff5$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
const $c2c8d7917d524ff5$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
const $c2c8d7917d524ff5$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
const $c2c8d7917d524ff5$var$TEXT_NODE_SELECTOR = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].join(',');
const $c2c8d7917d524ff5$var$SMART_LINK_BACKGROUND_COLOR = "var(--ds-surface-raised, #FFFFFF)";
const $c2c8d7917d524ff5$var$SMART_LINK_ACTIVE_COLOR = "var(--ds-background-selected, #E9F2FE)";
const $c2c8d7917d524ff5$var$getGradientWithColor = (color)=>{
    return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
};
const $c2c8d7917d524ff5$var$containerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'normal',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME}`]: {
            background: $c2c8d7917d524ff5$var$SMART_LINK_ACTIVE_COLOR
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c2c8d7917d524ff5$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: $c2c8d7917d524ff5$var$getGradientWithColor($c2c8d7917d524ff5$var$SMART_LINK_ACTIVE_COLOR)
        }
    }
});
const $c2c8d7917d524ff5$var$overlayStyles = {
    name: "1ckkn26",
    styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
};
const $c2c8d7917d524ff5$var$showOverlayStyles = {
    name: "1st01id",
    styles: "position:relative;visibility:visible"
};
const $c2c8d7917d524ff5$var$iconStyles = {
    name: "ulzjoo",
    styles: "span{display:flex;}"
};
const $c2c8d7917d524ff5$var$labelStyles = {
    name: "1x9ph6u",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
};
const $c2c8d7917d524ff5$var$iconAndLabelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    // Margin to avoid the background covering the link border
    marginRight: "var(--ds-space-025, 2px)",
    background: $c2c8d7917d524ff5$var$SMART_LINK_BACKGROUND_COLOR,
    color: "var(--ds-text-subtlest, #6B6E76)"
});
const $c2c8d7917d524ff5$var$overflowingContainerStyles = {
    name: "16sud",
    styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
};
const $c2c8d7917d524ff5$var$gradientStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    width: '2.5rem',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: $c2c8d7917d524ff5$var$getGradientWithColor($c2c8d7917d524ff5$var$SMART_LINK_BACKGROUND_COLOR)
});
const $c2c8d7917d524ff5$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
    const [showOverlay, setShowOverlay] = (0, $42omo.useState)(false);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [availableWidth, setAvailableWidth] = (0, $42omo.useState)(undefined);
    const maxOverlayWidth = (0, $42omo.useRef)(0);
    const minOverlayWidth = (0, $42omo.useRef)($c2c8d7917d524ff5$var$ESTIMATED_MIN_WIDTH_IN_PX);
    const parentWidth = (0, $42omo.useRef)(0);
    const containerRef = (0, $42omo.useRef)(null);
    const setVisibility = (0, $42omo.useCallback)(()=>{
        if (!containerRef.current || !maxOverlayWidth.current) return;
        const marker = (0, $5a27629e4ec16f4d$export$a0e2858e1d1976ea)(containerRef, `.${$c2c8d7917d524ff5$var$OVERLAY_MARKER_CLASSNAME}`);
        if (!marker) return;
        try {
            const oneLine = (0, $5a27629e4ec16f4d$export$be02a7fcf666d65d)(containerRef.current, marker);
            // Get the width of the available space to display overlay.
            // This is the width of the inline link itself. If the inline
            // is wrapped to the next line, this is width of the last line.
            const availableWidth = (0, $5a27629e4ec16f4d$export$ce3ffcce447cf028)(containerRef.current, marker) - $c2c8d7917d524ff5$var$PADDING_IN_PX - // Always leave at least the icon visible
            (oneLine ? $c2c8d7917d524ff5$var$ICON_WIDTH_IN_PX + $c2c8d7917d524ff5$var$PADDING_IN_PX : 0);
            setAvailableWidth(availableWidth);
            const canShowLabel = availableWidth > maxOverlayWidth.current;
            setShowLabel(canShowLabel);
            const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
            setShowOverlay(canShowOverlay);
        } catch  {
            // If something goes wrong, hide the overlay all together.
            setShowOverlay(false);
        }
    }, [
        isSelected
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // Using useLayoutEffect here.
        // 1) We want all to be able to determine whether to display label before
        //    the overlay becomes visible.
        // 2) We need to wait for the refs to be assigned to be able to do determine
        //    the width of the overlay.
        if (!containerRef.current) return;
        // This should run only once
        if (!maxOverlayWidth.current) {
            const iconAndLabel = (0, $5a27629e4ec16f4d$export$a0e2858e1d1976ea)(containerRef, `.${$c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME}`);
            const label = (0, $5a27629e4ec16f4d$export$a0e2858e1d1976ea)(containerRef, `.${$c2c8d7917d524ff5$var$OVERLAY_LABEL_CLASSNAME}`);
            if (iconAndLabel && label) {
                // Set overlay max (label + icon) and min (icon only) width.
                const { max: max, min: min } = (0, $5a27629e4ec16f4d$export$bdfd7a9bf7c62c86)(iconAndLabel, label);
                maxOverlayWidth.current = max;
                minOverlayWidth.current = min;
            }
        }
        if (isVisible) setVisibility();
    }, [
        setVisibility,
        isVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        // Find the closest block parent to observe size change
        const parent = containerRef?.current?.closest($c2c8d7917d524ff5$var$TEXT_NODE_SELECTOR);
        if (!parent) return;
        const updateOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((entries)=>{
            if (!isVisible) return;
            const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
            if (!size) return;
            if (!parentWidth.current) parentWidth.current = size;
            if (parentWidth.current === size) return;
            parentWidth.current = size;
            setVisibility();
        }, $c2c8d7917d524ff5$var$DEBOUNCE_IN_MS);
        const observer = new ResizeObserver(updateOverlay);
        observer.observe(parent);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isVisible,
        setVisibility
    ]);
    const intl = (0, $1cfRh.default)();
    const label = intl.formatMessage((0, $3RxtY.messages).inlineOverlay);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ...props,
        css: $c2c8d7917d524ff5$var$containerStyles,
        ref: containerRef
    }, children, isVisible && /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "aria-hidden": "true",
        className: $c2c8d7917d524ff5$var$OVERLAY_MARKER_CLASSNAME
    }, (0, $TfRUG.ZERO_WIDTH_JOINER)), /*#__PURE__*/ (0, $9K4OG.jsx)("a", {
        css: [
            $c2c8d7917d524ff5$var$overlayStyles,
            showOverlay && $c2c8d7917d524ff5$var$showOverlayStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: availableWidth && -availableWidth,
            width: availableWidth
        },
        "data-testid": testId,
        href: url,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$overflowingContainerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$iconAndLabelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$iconStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
        label: label,
        testId: `${testId}-icon`
    })), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$labelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c2c8d7917d524ff5$var$OVERLAY_LABEL_CLASSNAME,
        "data-testid": `${testId}-label`
    }, label)), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$gradientStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c2c8d7917d524ff5$var$OVERLAY_GRADIENT_CLASSNAME,
        "data-testid": `${testId}-gradient`
    }))))));
};
var $c2c8d7917d524ff5$export$2e2bcd8739ae039 = $c2c8d7917d524ff5$var$InlineCardOverlay;






var $jqKkl = parcelRequire("jqKkl");

function $9f76f5a8f109fd7b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $9f76f5a8f109fd7b$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $9f76f5a8f109fd7b$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const linkPosition = (0, $42omo.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $19cfbef4ec1a2073$export$2e2bcd8739ae039)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $5v798.isLocalStorageKeyDiscovered)((0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $5v798.markLocalStorageKeyDiscovered)((0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $42omo.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const handleOverlayChange = (0, $42omo.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
        setOverlayHoveredStyles(isHovered);
    }, [
        setOverlayHoveredStyles
    ]);
    const cardWithOverlay = (0, $42omo.useMemo)(()=>{
        if (shouldShowLinkOverlay && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c2c8d7917d524ff5$export$2e2bcd8739ae039), {
            isSelected: isSelected,
            isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onMouseEnter: ()=>handleOverlayChange(true),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onMouseLeave: ()=>handleOverlayChange(false),
            url: url
        }, children);
        return children;
    }, [
        shouldShowLinkOverlay,
        children,
        isSelected,
        isResolvedViewRendered,
        isInserted,
        isHovered,
        url,
        handleOverlayChange
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: shouldShowLinkPulse && $9f76f5a8f109fd7b$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                attributes: (0, $hrFA1.getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jqKkl.DiscoveryPulse), {
            localStorageKey: (0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $5v798.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, cardWithOverlay))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        cardWithOverlay,
        isInline,
        placeholderUniqId
    ]);
};









var $h8cpw = parcelRequire("h8cpw");

const $c168e1c9482bc793$export$a43fddf3dfb4c066 = ({ url: url, appearance: appearance, children: children })=>{
    const actions = (0, $h8cpw.useSmartLinkActions)({
        url: url,
        appearance: appearance
    });
    const preview = (0, $42omo.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const invokePreview = (0, $42omo.useCallback)(()=>{
        try {
            preview?.invoke();
        } catch  {}
    }, [
        preview
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children({
            canPreview: !!preview,
            invokePreview: invokePreview
        })
    });
};



var $4enQ2 = parcelRequire("4enQ2");

const $ab634df7485d5085$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode,
        selection: states.selectionState?.selection
    };
};
const $ab634df7485d5085$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $42omo.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, provider: provider, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isInserted, setIsInserted] = (0, $42omo.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $42omo.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const onResolve = (0, $42omo.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $6SJAP.pluginKey));
        if (metadata && metadata.type === 'REGISTER') (0, $9AGwg.registerRemoveOverlay)(()=>setIsInserted(false), metadata.info)(tr);
        else (0, $9AGwg.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $42omo.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $42omo.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode, selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $ab634df7485d5085$var$selector);
    const floatingToolbarNode = selection instanceof (0, $ks2lK.NodeSelection) && selection.node;
    // This is a prop to show Hover card, Hover card should be shown only in Live View and Classic Renderer (note when only Editor controls enabled we don't show in Live view)
    const showHoverPreview = floatingToolbarNode !== node && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    });
    const innerCardWithOpenButtonOverlay = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7FiWH.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
            editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
            view: view,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed,
                provider: provider,
                pluginInjectionApi: pluginInjectionApi,
                disablePreviewPanel: true
            })
        }), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const innerCardOriginal = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            showHoverPreview: false
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $42omo.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return (mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless) && ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') || (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        }));
    }, [
        mode,
        editorAppearance
    ]);
    let innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    if (mode === 'view' && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    })) {
        const url = node.attrs.url;
        const cardState = cardContext?.value?.store?.getState()[url];
        if (cardState) {
            const ari = (0, $226XV.getObjectAri)(cardState.details);
            const name = (0, $226XV.getObjectName)(cardState.details);
            const iconUrl = (0, $226XV.getObjectIconUrl)(cardState.details);
            const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
                ari: ari
            });
            const openPreviewPanel = cardContext?.value?.openPreviewPanel;
            const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
            const firePreviewPanelClickEvent = ({ previewType: previewType })=>{
                const store = cardContext?.value?.store;
                const urlState = store?.getState()[url || ''];
                if (pluginInjectionApi?.analytics?.actions) pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).CLICKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HOVER_LABEL,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        previewType: previewType,
                        destinationProduct: urlState?.details?.meta?.product ?? null,
                        destinationSubproduct: urlState?.details?.meta?.subproduct ?? null
                    }
                });
            };
            const innerCardWithPanelButtonOverlay = /*#__PURE__*/ (0, $l998X.jsx)((0, $c168e1c9482bc793$export$a43fddf3dfb4c066), {
                url: url,
                appearance: "inline",
                children: ({ canPreview: canPreview, invokePreview: invokePreview })=>{
                    const isPreviewModalAvailable = Boolean(canPreview && invokePreview);
                    // In view mode we show HoverLinkOverlay only with if preview mode or panel is available
                    // otherwise a use can click on smartlink itself to open the link in a new tab.
                    const isPreviewAvailable = isPreviewPanelAvailable || isPreviewModalAvailable;
                    // When inside preview panel iframe, hide the overlay button
                    const isInPreviewPanel = (0, $7ee1w.isWithinPreviewPanelIFrame)();
                    const showPanelButton = isInPreviewPanel ? isPreviewPanelAvailable : isPreviewAvailable;
                    if (isPreviewAvailable) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7FiWH.default), {
                        isVisible: isResolvedViewRendered,
                        url: url,
                        compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
                        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
                        view: view,
                        showPanelButton: showPanelButton,
                        showPanelButtonIcon: isPreviewAvailable && isPreviewPanelAvailable ? 'panel' : 'modal',
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: (event)=>{
                            if (isPreviewPanelAvailable) {
                                event.preventDefault();
                                openPreviewPanel?.({
                                    url: url,
                                    ari: ari || '',
                                    name: name || '',
                                    iconUrl: iconUrl,
                                    panelData: {
                                        embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $79vw2.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                                    }
                                });
                                firePreviewPanelClickEvent({
                                    previewType: 'panel'
                                });
                            } else if (isPreviewModalAvailable) {
                                event.preventDefault();
                                invokePreview?.();
                                firePreviewPanelClickEvent({
                                    previewType: 'modal'
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
                            node: node,
                            view: view,
                            getPos: getPos,
                            useAlternativePreloader: useAlternativePreloader,
                            actionOptions: actionOptions,
                            onResolve: onResolve,
                            onClick: onClick,
                            cardContext: cardContext,
                            isHovered: isHovered,
                            isPageSSRed: isPageSSRed,
                            provider: provider,
                            pluginInjectionApi: pluginInjectionApi,
                            showHoverPreview: mode === 'view' && showHoverPreview,
                            disablePreviewPanel: true
                        })
                    });
                    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
                        node: node,
                        view: view,
                        getPos: getPos,
                        useAlternativePreloader: useAlternativePreloader,
                        actionOptions: actionOptions,
                        onResolve: onResolve,
                        onClick: onClick,
                        cardContext: cardContext,
                        isHovered: isHovered,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        pluginInjectionApi: pluginInjectionApi,
                        showHoverPreview: mode === 'view' && showHoverPreview
                    });
                }
            });
            innerCard = innerCardWithPanelButtonOverlay;
        }
    }
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9f76f5a8f109fd7b$export$cc11bcf19366e14b), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});


const $e09bacbe103226ef$export$aff6291803939b05 = /*#__PURE__*/ (0, $42omo.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi, disablePreviewPanel: disablePreviewPanel })=>{
    const { url: url, data: data } = node.attrs;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const refId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const removeCardDispatched = (0, $42omo.useRef)(false);
    const { getState: getSmartlinkState } = cardContext?.value?.store || {};
    const cardState = getSmartlinkState?.()[url || ''];
    (0, $42omo.useEffect)(()=>{
        const id = refId.current;
        removeCardDispatched.current = false;
        return ()=>{
            if ((0, $1oCLl.expValEquals)('platform_editor_inline_card_dispatch_guard', 'isEnabled', true) && removeCardDispatched.current) return;
            removeCardDispatched.current = true;
            const { tr: tr } = view.state;
            (0, $9AGwg.removeCard)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $42omo.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $7YjFd.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $42omo.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $2P8Ax.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $9AGwg.registerCard)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $42omo.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $42omo.useCallback)((event)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            (0, $9Rg2N.visitCardLinkAnalytics)(editorAnalyticsApi, (0, $d925B.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open(url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick?.(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? handleOnClick : propsOnClick;
    const card = (0, $42omo.useMemo)(()=>{
        if ((isPageSSRed || cardState && (0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) && url) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel,
            hideIconLoadingSkeleton: true
        }, url);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed,
        disablePreviewPanel,
        cardState
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $l998X.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});
const $e09bacbe103226ef$var$WrappedInlineCardWithAwareness = (0, $cOfDZ.Card)((0, $ab634df7485d5085$export$2b341c5236b55a2), (0, $gndLe.default));
const $e09bacbe103226ef$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode
    };
};
function $e09bacbe103226ef$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt } = props;
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], $e09bacbe103226ef$var$selector);
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, $l998X.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    (0, $42omo.useEffect)(()=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) // Refresh cache in the background
        provider?.then((providerInstance)=>{
            providerInstance.refreshCache?.(props.node);
        });
    }, [
        provider,
        props.node
    ]);
    const inlineCardContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($e09bacbe103226ef$var$WrappedInlineCardWithAwareness, {
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                appearance: "inline",
                ...enableInlineUpgradeFeatures && (0, $hrFA1.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
            }),
            CompetitorPromptComponent
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f9yl5.SmartLinkDraggable), {
        url: url,
        appearance: (0, $f9yl5.SMART_LINK_APPEARANCE).INLINE,
        source: (0, $f9yl5.SMART_LINK_DRAG_TYPES).EDITOR,
        children: inlineCardContent
    });
}
const $e09bacbe103226ef$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };
module.exports["InlineCard"] = $e09bacbe103226ef$export$aff6291803939b05;
module.exports["InlineCardNodeView"] = $e09bacbe103226ef$export$2626b4e17577ac62;
module.exports["inlineCardNodeView"] = $e09bacbe103226ef$export$ebfb9e1798b8aa0e;

});

parcelRegister("6xEOh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $dxgIg = parcelRequire("dxgIg");


var $1dusJ = parcelRequire("1dusJ");


var $9Y9Mx = parcelRequire("9Y9Mx");


var $kiZiu = parcelRequire("kiZiu");


var $6bJyJ = parcelRequire("6bJyJ");


var $cOZT3 = parcelRequire("cOZT3");


var $kDG8M = parcelRequire("kDG8M");


var $9Ctkw = parcelRequire("9Ctkw");


var $kVA9C = parcelRequire("kVA9C");


var $gzsfl = parcelRequire("gzsfl");


var $1oCLl = parcelRequire("1oCLl");


var $d925B = parcelRequire("d925B");


var $4KOFJ = parcelRequire("4KOFJ");


var $hgeg8 = parcelRequire("hgeg8");


var $61p3e = parcelRequire("61p3e");

var $gVDfZ = parcelRequire("gVDfZ");


var $807Mc = parcelRequire("807Mc");


var $lqWNh = parcelRequire("lqWNh");

var $kTbzR = parcelRequire("kTbzR");

const $dc9639f396c30a74$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dusJ))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon"
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dxgIg))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon"
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Y9Mx))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon"
            })
    }
];
const $dc9639f396c30a74$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $hgeg8.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $hgeg8.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $hgeg8.alignRight)
    }
];
const $dc9639f396c30a74$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ctkw))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon"
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kVA9C))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon"
            })
    }
];
const $dc9639f396c30a74$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kDG8M)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl)))
    }
];
const $dc9639f396c30a74$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $gVDfZ.toolbarMessages).wrapLeft,
    center: (0, $61p3e.default).alignImageCenter,
    'wrap-right': (0, $gVDfZ.toolbarMessages).wrapRight,
    wide: (0, $61p3e.default).layoutWide,
    'full-width': (0, $61p3e.default).layoutFullWidth,
    'align-end': (0, $61p3e.default).alignImageRight,
    'align-start': (0, $61p3e.default).alignImageLeft
};
const $dc9639f396c30a74$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $dc9639f396c30a74$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $dc9639f396c30a74$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? // with extended experience, change alignment does not change media single width
        {
            ...node.attrs,
            layout: layout
        } : (0, $lqWNh.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $4KOFJ.insideTable)(state) || (0, $kTbzR.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).SELECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $dc9639f396c30a74$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $lqWNh.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $dc9639f396c30a74$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($dc9639f396c30a74$export$b978ceeb25a89f87[value]),
            selected: $dc9639f396c30a74$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $dc9639f396c30a74$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $dc9639f396c30a74$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($dc9639f396c30a74$export$b978ceeb25a89f87[value]),
            selected: $dc9639f396c30a74$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $dc9639f396c30a74$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $807Mc.Shortcut), null, (0, $hgeg8.tooltip)(layoutOption.keyboardShortcut))
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $dc9639f396c30a74$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $8m4tT.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        ...(0, $1oCLl.expValEquals)('editor_enable_image_alignment_in_expand', 'isEnabled', true) ? [] : [
            nodes.expand,
            nodes.nestedExpand
        ],
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $dc9639f396c30a74$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) || !selection.node || !nodeType || $dc9639f396c30a74$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $dc9639f396c30a74$var$mapIconsToToolbarItem($dc9639f396c30a74$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $dc9639f396c30a74$var$mapIconsToToolbarItem($dc9639f396c30a74$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $dc9639f396c30a74$var$mapIconsToToolbarItem($dc9639f396c30a74$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$dc9639f396c30a74$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$dc9639f396c30a74$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $dc9639f396c30a74$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) || !selection.node || !nodeType || $dc9639f396c30a74$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$dc9639f396c30a74$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$dc9639f396c30a74$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$dc9639f396c30a74$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $dc9639f396c30a74$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $dc9639f396c30a74$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($dc9639f396c30a74$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $dc9639f396c30a74$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $lqWNh.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $dc9639f396c30a74$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $dc9639f396c30a74$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var $dc9639f396c30a74$export$2e2bcd8739ae039 = $dc9639f396c30a74$var$buildLayoutButtons;
module.exports["alignmentIcons"] = $dc9639f396c30a74$export$45400139bf999022;
module.exports["wrappingIcons"] = $dc9639f396c30a74$export$88511ca1ca567d46;
module.exports["layoutToMessages"] = $dc9639f396c30a74$export$b978ceeb25a89f87;
module.exports["buildLayoutDropdown"] = $dc9639f396c30a74$export$31e29507a90f6f72;
module.exports["default"] = $dc9639f396c30a74$export$2e2bcd8739ae039;

});

parcelRegister("6JHzw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2P8Ax = parcelRequire("2P8Ax");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d7ZU3 = parcelRequire("d7ZU3");


var $2gkmX = parcelRequire("2gkmX");


var $7YjFd = parcelRequire("7YjFd");

var $iq4lN = parcelRequire("iq4lN");


var $16GCc = parcelRequire("16GCc");


var $f9yl5 = parcelRequire("f9yl5");


var $dh538 = parcelRequire("dh538");


var $hpUsb = parcelRequire("hpUsb");


var $9CM6e = parcelRequire("9CM6e");


var $1oCLl = parcelRequire("1oCLl");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $0vvte = parcelRequire("0vvte");

var $cV5SN = parcelRequire("cV5SN");


var $gndLe = parcelRequire("gndLe");


var $fJNzZ = parcelRequire("fJNzZ");


var $eLQM6 = parcelRequire("eLQM6");


var $eIleF = parcelRequire("eIleF");


var $hBNGD = parcelRequire("hBNGD");


var $dQwlz = parcelRequire("dQwlz");


var $aJdNi = parcelRequire("aJdNi");

const $e18b52ae184c6660$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $e18b52ae184c6660$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $e18b52ae184c6660$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIleF.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aJdNi.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIleF.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eLQM6.default), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.getDatasource = ()=>this.props.node.attrs.datasource;
        this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        };
        this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        };
        this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
class $e18b52ae184c6660$export$9dd55813d0ee0514 extends (0, $2gkmX.default) {
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dQwlz.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $gndLe.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $0vvte.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $fJNzZ.calcBreakoutWidth)(attrs.layout || (0, $hBNGD.DATASOURCE_DEFAULT_LAYOUT), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($e18b52ae184c6660$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.tableWidth = void 0;
        this.isNodeNested = void 0;
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
}



var $9AGwg = parcelRequire("9AGwg");


var $hrFA1 = parcelRequire("hrFA1");


var $cOfDZ = parcelRequire("cOfDZ");

class $008ad79e547fbc00$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $9AGwg.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = isPageSSRed ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt,
                    hideIconLoadingSkeleton: true
                }, url),
                this.gapCursorSpan()
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $f9yl5.SmartLinkDraggable), {
            url: url,
            appearance: (0, $f9yl5.SMART_LINK_APPEARANCE).BLOCK,
            source: (0, $f9yl5.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $l998X.jsx)(cardContext.Provider, {
                    value: cardContext.value,
                    children: cardInner
                }) : data ? cardInner : null
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $2P8Ax.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $9AGwg.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        };
        this.removeCardDispatched = false;
        this.gapCursorSpan = ()=>{
            const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if (browser.ie && browser.ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                contentEditable: true
            });
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.scrollContainer = (0, $7YjFd.findOverflowScrollParent)(props.view.dom) || undefined;
    }
}
const $008ad79e547fbc00$var$WrappedBlockCard = (0, $cOfDZ.Card)($008ad79e547fbc00$export$780882fb750d3c8d, (0, $iq4lN.default));
class $008ad79e547fbc00$export$d18ccd25c0d2c6b0 extends (0, $2gkmX.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $hrFA1.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $hrFA1.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)($008ad79e547fbc00$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]') && (0, $dh538.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $008ad79e547fbc00$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        };
        const isDatasource = (0, $hrFA1.isDatasourceNode)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $16GCc.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $e18b52ae184c6660$export$9dd55813d0ee0514)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $008ad79e547fbc00$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };
module.exports["BlockCardComponent"] = $008ad79e547fbc00$export$780882fb750d3c8d;
module.exports["blockCardNodeView"] = $008ad79e547fbc00$export$8c11099266e71f4;

});

parcelRegister("7IyZf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2P8Ax = parcelRequire("2P8Ax");


var $cUcZ5 = parcelRequire("cUcZ5");


var $9YoeD = parcelRequire("9YoeD");


var $eiA8Z = parcelRequire("eiA8Z");


var $2gkmX = parcelRequire("2gkmX");


var $7YjFd = parcelRequire("7YjFd");

var $6CRn4 = parcelRequire("6CRn4");

var $iq4lN = parcelRequire("iq4lN");


var $b3YrF = parcelRequire("b3YrF");


var $lqWNh = parcelRequire("lqWNh");


var $aFUXX = parcelRequire("aFUXX");


var $f9yl5 = parcelRequire("f9yl5");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $hpUsb = parcelRequire("hpUsb");

var $9ISlX = parcelRequire("9ISlX");


var $9CM6e = parcelRequire("9CM6e");


var $iu6m9 = parcelRequire("iu6m9");


var $9AGwg = parcelRequire("9AGwg");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $3UbBx = parcelRequire("3UbBx");

var $7U0RE = parcelRequire("7U0RE");

var $5dl3F = parcelRequire("5dl3F");
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $1OLls = parcelRequire("1OLls");

const $326b55d93a1eda54$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("&>div{", (0, $1OLls.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");



var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");








var $kVnOi = parcelRequire("kVnOi");




class $a50b525d2ced3713$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $3UbBx.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $3UbBx.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $aFUXX.breakoutWideScaleRatio));
        else return 0, $aFUXX.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $3UbBx.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $3UbBx.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $aFUXX.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $kVnOi.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $aFUXX.akEditorMediaResizeHandlerPadding)
        };
        const enable = {};
        (0, $7U0RE.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7U0RE.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $326b55d93a1eda54$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dl3F.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            onResizeStart: (0, $iu6m9.editorExperiment)('platform_synced_block', true) && (0, $dh538.fg)('platform_synced_block_patch_9') ? this.handleResizeStart : undefined,
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: this.calcOffsetLeft()
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $3UbBx.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $3UbBx.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $3UbBx.calcMediaPxWidth)({
                origWidth: (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.handleResizeStart = ()=>{
            const { view: view, getPos: getPos } = this.props;
            if (typeof getPos === 'function') {
                const pos = getPos();
                if (typeof pos === 'number') {
                    const tr = view.state.tr.setSelection((0, $ks2lK.NodeSelection).create(view.state.doc, pos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                }
            }
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $7U0RE.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, bodiedSyncBlock: bodiedSyncBlock } = this.props.view.state.schema.nodes;
            // Hide resizing guideline when embed is nested
            if (this.$pos && !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)(this.$pos, (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                bodiedSyncBlock
            ] : [
                layoutColumn,
                table,
                expand,
                nestedExpand
            ])) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $3UbBx.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}
$a50b525d2ced3713$export$2e2bcd8739ae039.defaultProps = {
    aspectRatio: (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) / (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT)
};



var $6JHzw = parcelRequire("6JHzw");


var $cOfDZ = parcelRequire("cOfDZ");

const $8daf0367de43e367$var$selector = (states)=>{
    return {
        widthStateLineLength: states.widthState?.lineLength || 0,
        widthStateWidth: states.widthState?.width || 0,
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $8daf0367de43e367$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $8daf0367de43e367$var$selector);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) / (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6CRn4.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a50b525d2ced3713$export$2e2bcd8739ae039), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled,
        children: smartCard
    });
};
class $8daf0367de43e367$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $9AGwg.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = isPageSSRed ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }, url) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }, url);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $f9yl5.SmartLinkDraggable), {
            url: url,
            appearance: (0, $f9yl5.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $f9yl5.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9ISlX.EmbedResizeMessageListener), {
                embedIframeRef: this.embedIframeRef,
                onHeightUpdate: this.onHeightUpdate,
                children: /*#__PURE__*/ (0, $l998X.jsx)($8daf0367de43e367$var$CardInner, {
                    pluginInjectionApi: pluginInjectionApi,
                    smartCard: smartCard,
                    hasPreview: hasPreview,
                    getPosSafely: this.getPosSafely,
                    view: view,
                    getLineLength: this.getLineLength,
                    eventDispatcher: this.props.eventDispatcher,
                    updateSize: this.updateSize,
                    getPos: getPos,
                    aspectRatio: aspectRatio,
                    allowResizing: allowResizing,
                    heightAlone: heightAlone,
                    cardProps: cardProps,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                })
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.state = void 0;
        this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch  {
            // Can blow up in rare cases, when node has been removed.
            }
        };
        this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: aspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT), (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $2P8Ax.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $9AGwg.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch  {}
        };
        this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        };
        /**
     * Defers line-length measurement until the embed card DOM has fully rendered.
     *
     * When put embed in the expand, reload the page and open that expand, the embed was collapsed.
     * Because the `.rich-media-item` can temporarily report `offsetWidth = 1`, as proportional width styles have not been applied yet.
     * Measuring at that moment would cache the bogus width and break resize calculations.
     * Scheduling a measurement on the next animation frame ensures layout has
     * settled. We then force the node view to re-render so `getLineLength`
     * re-runs and captures the correct width.
     */ this.scheduleLineLengthRemeasureRaf = (0, $2P8Ax.default)((view)=>{
            if (view) this.forceUpdate();
        });
        this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $lqWNh.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) {
                    const measuredWidth = domNode.offsetWidth;
                    if (measuredWidth <= 1) {
                        this.scheduleLineLengthRemeasureRaf(view);
                        return originalLineLength;
                    }
                    return measuredWidth;
                }
            }
            return originalLineLength;
        };
        /**
     * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
     * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
     * we will show embed window of appropriate size and avoid unnecessary content jumping.
     */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $2P8Ax.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        };
        this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.removeCardDispatched = false;
        this.scrollContainer = (0, $7YjFd.findOverflowScrollParent)(props.view.dom) || undefined;
        this.state = {
            hasPreview: true
        };
    }
}
const $8daf0367de43e367$export$a2e44368c194a658 = (props)=>{
    const width = (0, $b3YrF.useSharedPluginStateSelector)(props.pluginInjectionApi, 'width.width');
    const viewAsBlockCard = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6JHzw.BlockCardComponent), {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    }) : /*#__PURE__*/ (0, $l998X.jsx)($8daf0367de43e367$export$61b2782f78272a37, {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    });
};
const $8daf0367de43e367$var$WrappedEmbedCardWithCondition = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $8daf0367de43e367$export$a2e44368c194a658, $8daf0367de43e367$export$61b2782f78272a37);
const $8daf0367de43e367$var$WrappedEmbedCard = (0, $cOfDZ.Card)($8daf0367de43e367$var$WrappedEmbedCardWithCondition, (0, $iq4lN.default));
class $8daf0367de43e367$export$6789d7ecdc77631b extends (0, $2gkmX.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)($8daf0367de43e367$var$WrappedEmbedCard, {
            node: this.node,
            view: this.view,
            eventDispatcher: eventDispatcher,
            getPos: this.getPos,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]') && (0, $dh538.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $8daf0367de43e367$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        };
        return new $8daf0367de43e367$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps).init();
    };
module.exports["embedCardNodeView"] = $8daf0367de43e367$export$86904605fa83de6c;

});

parcelRegister("9YoeD", function(module, exports) {

var $cO9ey = parcelRequire("cO9ey");

var $aXG5V = parcelRequire("aXG5V");


var $5SAOw = parcelRequire("5SAOw");

class $93b3b1d5c7149b50$export$8cfd0a0bfa522949 extends (0, $cO9ey.Step) {
    apply(doc) {
        const target = doc.nodeAt(this.pos);
        if (!target) return (0, $aXG5V.StepResult).fail('No node at given position');
        if (target.isText) return (0, $aXG5V.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        const newNode = target.type.create(attrs, (0, $5SAOw.Fragment).empty, target.marks);
        const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $aXG5V.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        const target = doc.nodeAt(this.pos);
        return new $93b3b1d5c7149b50$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        const result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $93b3b1d5c7149b50$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $93b3b1d5c7149b50$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
    constructor(pos, attrs){
        super();
        this.pos = void 0;
        this.attrs = void 0;
        this.pos = pos;
        this.attrs = attrs;
    }
}
(0, $cO9ey.Step).jsonID('setAttrs', $93b3b1d5c7149b50$export$8cfd0a0bfa522949);
module.exports["SetAttrsStep"] = $93b3b1d5c7149b50$export$8cfd0a0bfa522949;

});

parcelRegister("7U0RE", function(module, exports) {
const $9d1645e455818659$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
const $9d1645e455818659$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
const $9d1645e455818659$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};
module.exports["snapTo"] = $9d1645e455818659$export$ce5a040a76868800;
module.exports["handleSides"] = $9d1645e455818659$export$8ee741c8b9b43371;
module.exports["imageAlignmentMap"] = $9d1645e455818659$export$9aaf3d5fbdfcf5c5;

});

parcelRegister("5dl3F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2daQU = parcelRequire("2daQU");


var $9MZd8 = parcelRequire("9MZd8");


var $aFUXX = parcelRequire("aFUXX");


var $d925B = parcelRequire("d925B");


var $gnMzP = parcelRequire("gnMzP");


var $eYlm5 = parcelRequire("eYlm5");


var $7U0RE = parcelRequire("7U0RE");

const $34afeecf093fc962$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $d925B.ACTION_SUBJECT).EMBEDS : (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $d925B.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $34afeecf093fc962$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $34afeecf093fc962$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $7U0RE.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $aFUXX.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $gnMzP.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        const nonZeroWidth = width || '100%'; // In SSR width could be 0 initially
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MZd8.Resizable), {
            ref: this.resizable,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: nonZeroWidth,
                // just content itself (no paddings)
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart
        }, children);
    }
    constructor(...args){
        super(...args);
        this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.state = {
            isResizing: false
        };
        this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints, onResizeStart: onResizeStart } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            if (onResizeStart) onResizeStart();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $eYlm5.gridTypeForLayout)(layout), newHighlights);
            });
        };
        this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $34afeecf093fc962$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $eYlm5.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        };
        this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $34afeecf093fc962$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $7U0RE.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($34afeecf093fc962$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $eYlm5.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $eYlm5.gridTypeForLayout)(layout), []);
            });
        };
    }
}
module.exports["default"] = $34afeecf093fc962$export$2e2bcd8739ae039;

});

parcelRegister("9MZd8", function(module, exports) {
"use strict";
var $720813ee147e427f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $720813ee147e427f$var$__assign = module.exports && module.exports.__assign || function() {
    $720813ee147e427f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $720813ee147e427f$var$__assign.apply(this, arguments);
};
var $720813ee147e427f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $720813ee147e427f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $720813ee147e427f$var$React = $720813ee147e427f$var$__importStar((parcelRequire("42omo")));

var $9QE25 = parcelRequire("9QE25");


var $720813ee147e427f$var$fast_memoize_1 = $720813ee147e427f$var$__importDefault((parcelRequire("hdx2V")));
var $720813ee147e427f$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $720813ee147e427f$var$clamp = $720813ee147e427f$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $720813ee147e427f$var$snap = $720813ee147e427f$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $720813ee147e427f$var$hasDirection = $720813ee147e427f$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $720813ee147e427f$var$findClosestSnap = $720813ee147e427f$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $720813ee147e427f$var$endsWith = $720813ee147e427f$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $720813ee147e427f$var$getStringSize = $720813ee147e427f$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($720813ee147e427f$var$endsWith(n, 'px')) return n;
    if ($720813ee147e427f$var$endsWith(n, '%')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vh')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vw')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vmax')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $720813ee147e427f$var$calculateNewMax = $720813ee147e427f$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $720813ee147e427f$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $720813ee147e427f$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $720813ee147e427f$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $720813ee147e427f$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $720813ee147e427f$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $720813ee147e427f$var$baseClassName = '__resizable_base__';
var $720813ee147e427f$var$Resizable = /** @class */ function(_super) {
    $720813ee147e427f$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $720813ee147e427f$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($720813ee147e427f$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $720813ee147e427f$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($720813ee147e427f$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $720813ee147e427f$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $720813ee147e427f$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $720813ee147e427f$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($720813ee147e427f$var$baseClassName);
        else element.className += $720813ee147e427f$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($720813ee147e427f$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($720813ee147e427f$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($720813ee147e427f$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($720813ee147e427f$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $720813ee147e427f$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $720813ee147e427f$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $720813ee147e427f$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $720813ee147e427f$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $720813ee147e427f$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $720813ee147e427f$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $720813ee147e427f$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $720813ee147e427f$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $720813ee147e427f$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($720813ee147e427f$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($720813ee147e427f$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($720813ee147e427f$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($720813ee147e427f$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($720813ee147e427f$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($720813ee147e427f$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $720813ee147e427f$var$React.createElement($9QE25.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $720813ee147e427f$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($720813ee147e427f$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $720813ee147e427f$var$React.createElement("div", $720813ee147e427f$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $720813ee147e427f$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $720813ee147e427f$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($720813ee147e427f$var$React.PureComponent);
module.exports.Resizable = $720813ee147e427f$var$Resizable;

});

parcelRegister("hdx2V", function(module, exports) {
//
// Main
//
function $c88d48d30306f53a$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $c88d48d30306f53a$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c88d48d30306f53a$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c88d48d30306f53a$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c88d48d30306f53a$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $c88d48d30306f53a$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c88d48d30306f53a$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c88d48d30306f53a$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c88d48d30306f53a$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c88d48d30306f53a$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c88d48d30306f53a$var$monadic : $c88d48d30306f53a$var$variadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c88d48d30306f53a$var$strategyVariadic(fn, options) {
    var strategy = $c88d48d30306f53a$var$variadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c88d48d30306f53a$var$strategyMonadic(fn, options) {
    var strategy = $c88d48d30306f53a$var$monadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $c88d48d30306f53a$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $c88d48d30306f53a$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c88d48d30306f53a$var$cacheDefault = {
    create: function create() {
        return new $c88d48d30306f53a$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $c88d48d30306f53a$var$memoize;
module.exports.strategies = {
    variadic: $c88d48d30306f53a$var$strategyVariadic,
    monadic: $c88d48d30306f53a$var$strategyMonadic
};

});

parcelRegister("cCTpf", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

var $cO9ey = parcelRequire("cO9ey");

const $e04235b8f81a60dd$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $e04235b8f81a60dd$export$c1b7e6427b2a2113 extends (0, $cO9ey.Step) {
    invert() {
        return new $e04235b8f81a60dd$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $e04235b8f81a60dd$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(pos, prev, next){
        super();
        this.prev = void 0;
        this.next = void 0;
        this.pos = void 0;
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $cO9ey.Step).jsonID($e04235b8f81a60dd$export$3f33e36adb7672cc, $e04235b8f81a60dd$export$c1b7e6427b2a2113);
module.exports["TableSortStep"] = $e04235b8f81a60dd$export$c1b7e6427b2a2113;

});

parcelRegister("fYKTL", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6dGgK = parcelRequire("6dGgK");


var $2daQU = parcelRequire("2daQU");


var $eTj7Y = parcelRequire("eTj7Y");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");

const $3d3ae8905552ef3e$export$bc90872e265d166e = 12;
const $3d3ae8905552ef3e$var$key = new (0, $ks2lK.PluginKey)('gridPlugin');
const $3d3ae8905552ef3e$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($3d3ae8905552ef3e$var$key, props);
        dispatch(tr);
        return true;
    };
const $3d3ae8905552ef3e$var$sides = [
    'left',
    'right'
];
const $3d3ae8905552ef3e$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $3d3ae8905552ef3e$export$bc90872e265d166e && maxHighlight >= $3d3ae8905552ef3e$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $3d3ae8905552ef3e$export$bc90872e265d166e + size : true);
};
const $3d3ae8905552ef3e$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $aFUXX.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $3d3ae8905552ef3e$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridLine', $3d3ae8905552ef3e$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $aFUXX.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $3d3ae8905552ef3e$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $3d3ae8905552ef3e$export$bc90872e265d166e;
    for(let i = 0; i <= $3d3ae8905552ef3e$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $3d3ae8905552ef3e$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $3d3ae8905552ef3e$var$Grid = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$3d3ae8905552ef3e$var$lineLengthGridLines(highlight),
        ...$3d3ae8905552ef3e$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none'
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $3d3ae8905552ef3e$var$ThemedGrid = (0, $6dGgK.b)($3d3ae8905552ef3e$var$Grid);
const $3d3ae8905552ef3e$var$selector = (states)=>{
    return {
        width: states.widthState?.width,
        visible: states.gridState?.visible,
        gridType: states.gridState?.gridType,
        highlight: states.gridState?.highlight
    };
};
const $3d3ae8905552ef3e$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, visible: visible, gridType: gridType, highlight: highlight } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $3d3ae8905552ef3e$var$selector);
    if (visible === undefined || !highlight) return null;
    if ((0, $1oCLl.expValEquals)('platform_editor_remove_grid_init_reflow', 'isEnabled', true)) {
        if (!visible || !highlight) return null;
    } else {
        if (visible === undefined || !highlight) return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($3d3ae8905552ef3e$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $aFUXX.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight
    });
};
const $3d3ae8905552ef3e$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $3d3ae8905552ef3e$var$gridPMPlugin = new (0, $1S4f7.SafePlugin)({
    key: $3d3ae8905552ef3e$var$key,
    state: {
        init () {
            return $3d3ae8905552ef3e$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($3d3ae8905552ef3e$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $3d3ae8905552ef3e$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $3d3ae8905552ef3e$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $3d3ae8905552ef3e$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$3d3ae8905552ef3e$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $eTj7Y.isSSR)()) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($3d3ae8905552ef3e$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    };
};
module.exports["gridPlugin"] = $3d3ae8905552ef3e$export$c090e341e8f725a9;

});

parcelRegister("4HPW1", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $kfJSC = parcelRequire("kfJSC");

const $48cec7a5ea226746$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $48cec7a5ea226746$export$e331ccfa6f694c99 = (range)=>!!(typeof range === 'object' && range && 'start' in range && 'end' in range);
const $48cec7a5ea226746$export$75d81fc396e386db = (pos)=>$48cec7a5ea226746$export$7e4aa119212bc614(pos.x);
const $48cec7a5ea226746$export$3fa50479f031580 = (keys, guidelines)=>{
    if (guidelines.length === 0) return 'none';
    // Check for default guidelines on key
    if (keys.some((key)=>[
            'grid_',
            'wide_',
            'full_width'
        ].some((defaultGuideline)=>key.indexOf(defaultGuideline) >= 0))) return 'default';
    // Check for temporary guidelines
    if (keys.some((key)=>[
            'media_'
        ].some((temoporaryGuideline)=>key.indexOf(temoporaryGuideline) >= 0))) return 'temporary';
    // Check for relative guidelines
    if (keys.some((key)=>[
            'relative_'
        ].some((relativeGuideline)=>key.indexOf(relativeGuideline) >= 0))) return 'relative';
    return 'none';
};
const $48cec7a5ea226746$export$d52a13210f6817c5 = (containerWidth)=>{
    const padding = containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    return Math.min(containerWidth - padding * 2, (0, $aFUXX.akEditorFullWidthLayoutWidth)) / 2;
};
const $48cec7a5ea226746$export$c7bf42817f6e4244 = (mediaSingle, editorWidth = (0, $aFUXX.akEditorDefaultLayoutWidth))=>{
    if (mediaSingle.type !== mediaSingle.type.schema.nodes.mediaSingle) return null;
    const mediaNode = mediaSingle.firstChild;
    const { width: width, height: height } = mediaNode?.attrs || {};
    // e.g. external image
    if (!width || !height) return null;
    const ratio = parseFloat((height / width).toFixed(2));
    if (!mediaSingle.attrs.width) return {
        width: width,
        height: height,
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
    const pixelWidth = (0, $kfJSC.getMediaSinglePixelWidth)(mediaSingle.attrs.width, editorWidth, mediaSingle.attrs.widthType);
    return {
        width: (0, $kfJSC.roundToNearest)(pixelWidth),
        height: (0, $kfJSC.roundToNearest)(pixelWidth * ratio),
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
};
module.exports["isVerticalPosition"] = $48cec7a5ea226746$export$75d81fc396e386db;
module.exports["getGuidelineTypeFromKey"] = $48cec7a5ea226746$export$3fa50479f031580;
module.exports["getContainerWidthOrFullEditorWidth"] = $48cec7a5ea226746$export$d52a13210f6817c5;
module.exports["getMediaSingleDimensions"] = $48cec7a5ea226746$export$c7bf42817f6e4244;

});

parcelRegister("6MTPr", function(module, exports) {
const $7d01492d97569010$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $7d01492d97569010$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $7d01492d97569010$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};
module.exports["getGuidelinesWithHighlights"] = $7d01492d97569010$export$529f80a31b4cd2ac;

});

parcelRegister("8b5jG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2daQU = parcelRequire("2daQU");


var $9MZd8 = parcelRequire("9MZd8");


var $1cfRh = parcelRequire("1cfRh");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $5duTD = parcelRequire("5duTD");


var $7QdQz = parcelRequire("7QdQz");

const $d4ce0c3cc8105bda$var$resizerLabelStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: "var(--ds-space-0, 0px)",
    width: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-0, 0px)",
    zIndex: 'layer' // 400 same z-index as the floating toolbar
});
const $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $d4ce0c3cc8105bda$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $d4ce0c3cc8105bda$var$ResizerNext = (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $42omo.useState)(false);
    const resizable = (0, $42omo.useRef)(null);
    const resizeHandleThumbRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props;
    const onResizeStart = (0, $42omo.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $42omo.useCallback)((_event, _direction, _elementRef, delta)=>{
        if (!handleResize) return;
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        handleResize(originalState, delta);
    }, [
        handleResize
    ]);
    const onResizeStop = (0, $42omo.useCallback)((_event, _direction, _elementRef, delta)=>{
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        setIsResizing(false);
        handleResizeStop(originalState, delta);
    }, [
        handleResizeStop
    ]);
    const handles = {
        left: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(handleClassName ?? (0, $7QdQz.resizerHandleClassName), 'left', handleSize, handleAlignmentMethod),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(handleClassName ?? (0, $7QdQz.resizerHandleClassName), 'right', handleSize, handleAlignmentMethod)
    };
    const baseHandleStyles = {
        width: handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)",
        zIndex: (0, $7QdQz.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const offset = handlePositioning === 'adjacent' ? `calc(${baseHandleStyles.width} * -1)` : `calc(${baseHandleStyles.width} * -0.5)`;
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const nextHandleStyles = $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES.reduce((result, position)=>({
            ...result,
            [position]: {
                ...baseHandleStyles,
                [position]: offset,
                ...handleStyles?.[position]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, (0, $7QdQz.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $7QdQz.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHoverZoneClassName), {
        [(0, $7QdQz.resizerExtendedZone)]: needExtendedResizeZone
    });
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const handleComponent = (0, $42omo.useMemo)(()=>{
        return $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES.reduce((result, position)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $7QdQz.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position}-thumb`,
                "aria-label": formatMessage((0, $5duTD.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result,
                [position]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent,
        formatMessage
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $42omo.useMemo)(()=>{
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MZd8.Resizable), {
        ref: resizable,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        size: {
            width: width ?? 'auto',
            // just content itself (no paddings)
            height: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $7QdQz.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: resizerZoneClassName,
        ref: (ref)=>childrenDOMRef && childrenDOMRef(ref)
    }, children), labelComponent && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d4ce0c3cc8105bda$var$resizerLabelStyles
    }, labelComponent));
};
const $d4ce0c3cc8105bda$var$_default_1 = /*#__PURE__*/ (0, $42omo.forwardRef)($d4ce0c3cc8105bda$var$ResizerNext);
var $d4ce0c3cc8105bda$export$2e2bcd8739ae039 = $d4ce0c3cc8105bda$var$_default_1;
module.exports["default"] = $d4ce0c3cc8105bda$export$2e2bcd8739ae039;

});

parcelRegister("7QdQz", function(module, exports) {
/*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/ const $18d786e757e244a7$export$a06160db3520e5a2 = 'resizer-item';
const $18d786e757e244a7$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $18d786e757e244a7$export$10b67c6ff1748bd = 'resizer-is-extended';
const $18d786e757e244a7$export$6afc20f0ff6d041 = 'resizer-handle';
const $18d786e757e244a7$export$a5792d7e2a486d41 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-track`;
const $18d786e757e244a7$export$2201bc1aaee73f36 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-thumb`;
const $18d786e757e244a7$export$97a99610b6f0a178 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-danger`;
const $18d786e757e244a7$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $18d786e757e244a7$export$b5fa87f62ced4967 = 3;
const $18d786e757e244a7$export$3d867927ebf9bc1f = 1;
module.exports["resizerItemClassName"] = $18d786e757e244a7$export$a06160db3520e5a2;
module.exports["resizerHoverZoneClassName"] = $18d786e757e244a7$export$c42cdcfd48254bda;
module.exports["resizerExtendedZone"] = $18d786e757e244a7$export$10b67c6ff1748bd;
module.exports["resizerHandleClassName"] = $18d786e757e244a7$export$6afc20f0ff6d041;
module.exports["resizerHandleTrackClassName"] = $18d786e757e244a7$export$a5792d7e2a486d41;
module.exports["resizerHandleThumbClassName"] = $18d786e757e244a7$export$2201bc1aaee73f36;
module.exports["resizerDangerClassName"] = $18d786e757e244a7$export$97a99610b6f0a178;
module.exports["handleWrapperClass"] = $18d786e757e244a7$export$b123b2c8a2536d05;
module.exports["resizerHandleThumbWidth"] = $18d786e757e244a7$export$b5fa87f62ced4967;
module.exports["resizerHandleZIndex"] = $18d786e757e244a7$export$3d867927ebf9bc1f;

});

parcelRegister("9AGwg", function(module, exports) {

var $6SJAP = parcelRequire("6SJAP");

const $c384132222c1e261$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $6SJAP.pluginKey), action);
};
const $c384132222c1e261$export$2b7045d36e3e01d4 = (url)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $c384132222c1e261$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $c384132222c1e261$export$af5afab36c1f83f6 = (info)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $c384132222c1e261$export$3301f76e6efaf85e = (info)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $c384132222c1e261$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $c384132222c1e261$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $c384132222c1e261$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $c384132222c1e261$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $c384132222c1e261$export$63a1bdeb24c4dd9f = (url, attributes)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_RESOLVED_TOOLBAR_ATTRIBUTES',
            url: url,
            attributes: attributes
        });
const $c384132222c1e261$export$c9a25858ed46807c = (layout)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $c384132222c1e261$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $c384132222c1e261$export$83c364d103479f90 = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $c384132222c1e261$export$bd1cd60a9b31da5e = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $c384132222c1e261$export$2c79f54b873d04be = (modalType)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $c384132222c1e261$export$e545bc176b552938 = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $c384132222c1e261$export$a2922c2e95ff48f7 = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $c384132222c1e261$export$53e36aa41bbce673 = (tr, datasourceStash)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $c384132222c1e261$export$4b1fde77584594b5 = (tr, url)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });
module.exports["resolveCard"] = $c384132222c1e261$export$2b7045d36e3e01d4;
module.exports["queueCards"] = $c384132222c1e261$export$5312e3a17c3f6d3;
module.exports["registerCard"] = $c384132222c1e261$export$af5afab36c1f83f6;
module.exports["removeCard"] = $c384132222c1e261$export$3301f76e6efaf85e;
module.exports["registerRemoveOverlay"] = $c384132222c1e261$export$a3d5a5cb818ce9d9;
module.exports["registerSmartCardEvents"] = $c384132222c1e261$export$55288255874724a1;
module.exports["setProvider"] = $c384132222c1e261$export$1572b3eade6662f9;
module.exports["setDatasourceTableRef"] = $c384132222c1e261$export$f9c5be16586d220a;
module.exports["setResolvedToolbarAttributes"] = $c384132222c1e261$export$63a1bdeb24c4dd9f;
module.exports["setCardLayout"] = $c384132222c1e261$export$c9a25858ed46807c;
module.exports["setCardLayoutAndDatasourceTableRef"] = $c384132222c1e261$export$dd3435a1df9b2a3f;
module.exports["showLinkToolbar"] = $c384132222c1e261$export$83c364d103479f90;
module.exports["hideLinkToolbar"] = $c384132222c1e261$export$bd1cd60a9b31da5e;
module.exports["showDatasourceModal"] = $c384132222c1e261$export$2c79f54b873d04be;
module.exports["hideDatasourceModal"] = $c384132222c1e261$export$e545bc176b552938;
module.exports["clearOverlayCandidate"] = $c384132222c1e261$export$a2922c2e95ff48f7;
module.exports["setDatasourceStash"] = $c384132222c1e261$export$53e36aa41bbce673;
module.exports["removeDatasourceStash"] = $c384132222c1e261$export$4b1fde77584594b5;

});

parcelRegister("hrFA1", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $1xKpK = parcelRequire("1xKpK");


var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");

var $iB8ko = parcelRequire("iB8ko");


var $6SJAP = parcelRequire("6SJAP");

const $4c917f5b4041cdb8$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $4c917f5b4041cdb8$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $ks2lK.NodeSelection)) return $4c917f5b4041cdb8$export$71376de76fa352d1(state.selection.node.type);
};
const $4c917f5b4041cdb8$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $4c917f5b4041cdb8$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $4c917f5b4041cdb8$export$a6fcef6250c64f76 = (node, info)=>$4c917f5b4041cdb8$export$fe497395c317d106($4c917f5b4041cdb8$export$15bc29504ff06986(node), info);
const $4c917f5b4041cdb8$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $6SJAP.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $4c917f5b4041cdb8$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $4c917f5b4041cdb8$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$4c917f5b4041cdb8$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $4c917f5b4041cdb8$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$4c917f5b4041cdb8$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $4c917f5b4041cdb8$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $1xKpK.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $4c917f5b4041cdb8$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $4c917f5b4041cdb8$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $4c917f5b4041cdb8$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $4c917f5b4041cdb8$export$48ba7bd006cffb5e(node.attrs);
};
const $4c917f5b4041cdb8$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $4c917f5b4041cdb8$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $4c917f5b4041cdb8$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $4c917f5b4041cdb8$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $ks2lK.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};
module.exports["appearanceForNodeType"] = $4c917f5b4041cdb8$export$71376de76fa352d1;
module.exports["selectedCardAppearance"] = $4c917f5b4041cdb8$export$a5ff7aecd33e6813;
module.exports["titleUrlPairFromNode"] = $4c917f5b4041cdb8$export$15bc29504ff06986;
module.exports["displayInfoForCard"] = $4c917f5b4041cdb8$export$a6fcef6250c64f76;
module.exports["findCardInfo"] = $4c917f5b4041cdb8$export$f3f2332ef0853029;
module.exports["isEmbedSupportedAtPosition"] = $4c917f5b4041cdb8$export$b31d21baab1bb9f;
module.exports["isBlockSupportedAtPosition"] = $4c917f5b4041cdb8$export$290208dc31723a19;
module.exports["getResolvedAttributesFromStore"] = $4c917f5b4041cdb8$export$a0e5429851d8d8a9;
module.exports["isDatasourceConfigEditable"] = $4c917f5b4041cdb8$export$c677d64dd26b7aa2;
module.exports["isDatasourceNode"] = $4c917f5b4041cdb8$export$962cfe99b8da8614;
module.exports["focusEditorView"] = $4c917f5b4041cdb8$export$bab6ff782a349bd3;
module.exports["getAwarenessProps"] = $4c917f5b4041cdb8$export$ea8b03e32bcc0b2d;

});

parcelRegister("9Rg2N", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");

var $iGbqR = parcelRequire("iGbqR");


var $6xEOh = parcelRequire("6xEOh");

var $doRn8 = parcelRequire("doRn8");


var $i9vfM = parcelRequire("i9vfM");


var $ahUGI = parcelRequire("ahUGI");

var $3RxtY = parcelRequire("3RxtY");

var $61p3e = parcelRequire("61p3e");

var $fpEzC = parcelRequire("fpEzC");

var $ckqYV = parcelRequire("ckqYV");


var $0vvte = parcelRequire("0vvte");

var $gnMzP = parcelRequire("gnMzP");


var $iHzeA = parcelRequire("iHzeA");


var $16GCc = parcelRequire("16GCc");


var $91bcx = parcelRequire("91bcx");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $1yB28 = parcelRequire("1yB28");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $1Zr9M = parcelRequire("1Zr9M");


var $dZMVn = parcelRequire("dZMVn");


var $8tdj3 = parcelRequire("8tdj3");


var $fIcbd = parcelRequire("fIcbd");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $btzjy = parcelRequire("btzjy");


var $6SJAP = parcelRequire("6SJAP");


var $hrFA1 = parcelRequire("hrFA1");


var $kXd3n = parcelRequire("kXd3n");


var $8eb8d = parcelRequire("8eb8d");


var $fezbA = parcelRequire("fezbA");


var $iDVNw = parcelRequire("iDVNw");


var $iVRHt = parcelRequire("iVRHt");


var $dzW6s = parcelRequire("dzW6s");


var $lB6pw = parcelRequire("lB6pw");


var $l1M3D = parcelRequire("l1M3D");


var $hh4Zj = parcelRequire("hh4Zj");

const $98c7df126d8bab2d$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $doRn8.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $8m4tT.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $d925B.ACTION).DELETED
    });
const $98c7df126d8bab2d$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod, resolvedAttributes)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            const shouldIncludeResolvedAttributes = (0, $1oCLl.expValEquals)('cc_integrations_editor_open_link_click_analytics', 'isEnabled', true);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod, shouldIncludeResolvedAttributes ? resolvedAttributes : undefined))(tr);
            dispatch(tr);
        }
        return true;
    };
const $98c7df126d8bab2d$var$fireOpenLinkToolbarAnalytics = (editorAnalyticsApi, inputMethod, resolvedAttributes = {})=>(state, dispatch)=>{
        const linkAnalyticsRecorded = $98c7df126d8bab2d$export$7ee76be08aa43a42(editorAnalyticsApi, inputMethod, resolvedAttributes)(state, dispatch);
        if (!linkAnalyticsRecorded) return false;
        if ((0, $1oCLl.expValEquals)('cc_integrations_editor_open_link_click_analytics', 'isEnabled', true)) editorAnalyticsApi?.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).OPEN_LINK,
            attributes: {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
        return true;
    };
const $98c7df126d8bab2d$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $98c7df126d8bab2d$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $6SJAP.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $hrFA1.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $0vvte.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $3RxtY.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const richMediaElement = element.querySelector(`.${(0, $gnMzP.richMediaClassName)}`);
                    if (!(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                        exposure: true
                    })) return richMediaElement;
                    if (richMediaElement) return richMediaElement;
                }
                return element;
            },
            items: $98c7df126d8bab2d$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $8eb8d.editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled)
        };
    };
};
const $98c7df126d8bab2d$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $hrFA1.displayInfoForCard)(node, (0, $hrFA1.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $d925B.ACTION).UNLINK
    });
    return ()=>false;
};
const $98c7df126d8bab2d$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions, areAnyNewToolbarFlagsEnabled)=>{
    if (areAnyNewToolbarFlagsEnabled) return (0, $6xEOh.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $6xEOh.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $98c7df126d8bab2d$var$withToolbarMetadata = (command)=>(0, $doRn8.commandWithMetadata)(command, {
        inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
    });
const $98c7df126d8bab2d$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hh4Zj.ToolbarViewedEvent), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $98c7df126d8bab2d$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $hrFA1.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $81OAa.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $hrFA1.displayInfoForCard)(node, (0, $hrFA1.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
        const currentAppearance = (0, $hrFA1.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $hrFA1.isDatasourceNode)(node);
        const pluginState = (0, $6SJAP.pluginKey).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $16GCc.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $8eb8d.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $98c7df126d8bab2d$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                    title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                    showTitle: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: (0, $91bcx.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode)
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true)
                }
            ];
            const openPreviewPanelItems = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
                exposure: true
            }) ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l1M3D.OpenPreviewPanelToolbarButton), {
                            node: node,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ] : [];
            const resolvedToolbarAttributes = url ? pluginState?.resolvedToolbarAttributesByUrl[url] ?? {} : {};
            const openLinkToolbarItem = {
                id: 'editor.link.openLink',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                metadata: metadata,
                className: 'hyperlink-open-link',
                title: intl.formatMessage((0, $fpEzC.linkMessages).openLink),
                onClick: $98c7df126d8bab2d$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                href: url,
                target: '_blank'
            };
            const toolbarItems = areAllNewToolbarFlagsDisabled ? [
                ...editItems,
                ...commentItems,
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                {
                    type: 'separator'
                },
                ...$98c7df126d8bab2d$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $61p3e.default).remove),
                    onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...$98c7df126d8bab2d$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'separator',
                    fullHeight: true
                },
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $98c7df126d8bab2d$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions, !areAllNewToolbarFlagsDisabled);
                if (alignmentOptions.length && areAllNewToolbarFlagsDisabled) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$98c7df126d8bab2d$var$getToolbarViewedItem(url, currentAppearance), areAllNewToolbarFlagsDisabled ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dzW6s.LinkToolbarAppearance), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability,
                            areAnyNewToolbarFlagsEnabled: false
                        }, "link-appearance")
                } : (0, $lB6pw.getLinkAppearanceDropdown)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }), ...showDatasourceAppearance && areAllNewToolbarFlagsDisabled ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kXd3n.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                            })
                    }
                ] : [], ...!areAllNewToolbarFlagsDisabled ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if (!areAllNewToolbarFlagsDisabled) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                                    pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                                    label: intl.formatMessage((0, $61p3e.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $aFUXX.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $61p3e.default).delete),
                                onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                                    label: intl.formatMessage((0, $61p3e.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $98c7df126d8bab2d$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi, areAnyNewToolbarFlagsEnabled)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))),
            onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...areAnyNewToolbarFlagsEnabled ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $98c7df126d8bab2d$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))),
        title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).settingsLink),
        onClick: $98c7df126d8bab2d$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $i9vfM.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $98c7df126d8bab2d$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    toolbarItems.push(...$98c7df126d8bab2d$var$getToolbarViewedItem(node?.attrs?.url, currentAppearance ?? 'url'));
    const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $dzW6s.LinkToolbarAppearance), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true,
                    areAnyNewToolbarFlagsEnabled: false
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kXd3n.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $lB6pw.getLinkAppearanceDropdown)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true,
            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
    const pluginState = (0, $6SJAP.pluginKey).getState(state);
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, false),
                currentAppearance: "datasource",
                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
            }, "edit-toolbar-item")
    });
    if (node?.attrs?.url) {
        toolbarItems.push({
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $fpEzC.linkMessages).openLink),
            onClick: $98c7df126d8bab2d$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
            href: node.attrs.url,
            target: '_blank'
        });
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'separator'
        });
    }
    if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $61p3e.default).remove),
        onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                            pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                            label: intl.formatMessage((0, $61p3e.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $61p3e.default).delete),
                        onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                            label: intl.formatMessage((0, $61p3e.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $98c7df126d8bab2d$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $98c7df126d8bab2d$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, _state)=>{
        const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url",
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
                showTitle: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if (!areAllNewToolbarFlagsDisabled) {
            const hyperlinkAppearance = [
                (0, $iVRHt.getCustomHyperlinkAppearanceDropdown)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $98c7df126d8bab2d$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hh4Zj.ToolbarViewedEvent), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hh4Zj.ToolbarViewedEvent), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iDVNw.HyperlinkToolbarAppearance), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $98c7df126d8bab2d$export$d5ca70670b9f6b9 = (options, api)=>(intl, _link)=>{
        /**
   * Require either provider to be supplied (controls link preferences)
   * Or explicit user preferences config in order to enable button
   */ if ((options.provider || options.userPreferencesLink) && !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) return [
            {
                type: 'separator'
            },
            $98c7df126d8bab2d$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };
module.exports["visitCardLinkAnalytics"] = $98c7df126d8bab2d$export$7ee76be08aa43a42;
module.exports["floatingToolbar"] = $98c7df126d8bab2d$export$4850df084251d287;
module.exports["shouldRenderToolbarPulse"] = $98c7df126d8bab2d$export$ddeab6943680f5be;
module.exports["getStartingToolbarItems"] = $98c7df126d8bab2d$export$bb790f15a666b7f0;
module.exports["getEndingToolbarItems"] = $98c7df126d8bab2d$export$d5ca70670b9f6b9;

});

parcelRegister("btzjy", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");

var $eKaDU = parcelRequire("eKaDU");

var $iGbqR = parcelRequire("iGbqR");


var $doRn8 = parcelRequire("doRn8");


var $i9vfM = parcelRequire("i9vfM");


var $bYZ53 = parcelRequire("bYZ53");

var $b0F8r = parcelRequire("b0F8r");

var $2pjJ5 = parcelRequire("2pjJ5");

var $6tl2G = parcelRequire("6tl2G");


var $ks2lK = parcelRequire("ks2lK");


var $ke2AI = parcelRequire("ke2AI");


var $iu6m9 = parcelRequire("iu6m9");


var $9AGwg = parcelRequire("9AGwg");


var $6SJAP = parcelRequire("6SJAP");


var $1yFQS = parcelRequire("1yFQS");


var $hrFA1 = parcelRequire("hrFA1");

/**
 * Attempt to replace the link into the respective card.
 */ function $09c77129dcdfe9d0$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $81OAa.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $1yFQS.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)($head);
    if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
        // Add the annotation mark on to the inlineCard node and the trailing space node.
        tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
    });
    return $pos.node($pos.depth - 1).type.name;
}
const $09c77129dcdfe9d0$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>(editorState, dispatch)=>{
        const state = (0, $6SJAP.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        let cardAdf = null;
        // If an embed card transformer is provided and the resolved card is an embedCard,
        // attempt to transform it into an alternative node representation first.
        if (cardData.type === 'embedCard' && embedCardNodeTransformer) cardAdf = embedCardNodeTransformer(schema, cardData.attrs) ?? null;
        if (!cardAdf) cardAdf = (0, $6tl2G.processRawValue)(schema, cardData) ?? null;
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$09c77129dcdfe9d0$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $b0F8r.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $doRn8.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $9AGwg.resolveCard)(url)((0, $ke2AI.closeHistory)(tr)));
        return true;
    };
const $09c77129dcdfe9d0$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $6SJAP.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $d925B.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $b0F8r.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $doRn8.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $9AGwg.resolveCard)(request.url)(tr));
        return true;
    };
const $09c77129dcdfe9d0$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $2pjJ5.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1yFQS.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: appearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    if (analyticsAction) (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $9AGwg.queueCards)(requests)(tr);
};
const $09c77129dcdfe9d0$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $2pjJ5.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1yFQS.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $9AGwg.queueCards)(requests)(tr);
};
const $09c77129dcdfe9d0$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $d925B.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $i9vfM.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $doRn8.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $d925B.ACTION).CHANGED_TYPE
    });
    return (0, $9AGwg.queueCards)(requests)(state.tr);
};
const $09c77129dcdfe9d0$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos) tr = $09c77129dcdfe9d0$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, text, href);
        $09c77129dcdfe9d0$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $eKaDU.SMART_LINK_TYPE).URL,
                    previousType: (0, $hrFA1.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $09c77129dcdfe9d0$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos) tr = $09c77129dcdfe9d0$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.setMeta('addToHistory', false));
        return true;
    };
const $09c77129dcdfe9d0$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $hrFA1.selectedCardAppearance)(state);
        const tr = $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, href, href);
        $09c77129dcdfe9d0$export$717aabd99c4fc685(state, tr, (0, $d925B.INPUT_METHOD).MANUAL, (0, $d925B.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $09c77129dcdfe9d0$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $09c77129dcdfe9d0$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $doRn8.addLinkMetadata)(state.selection, tr, {
                action: (0, $d925B.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.unlinkPayload)((0, $d925B.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $09c77129dcdfe9d0$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $09c77129dcdfe9d0$export$c8301558911030d4(state, (0, $d925B.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $doRn8.addLinkMetadata)(state.selection, tr, {
                    action: (0, $d925B.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $hrFA1.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? $09c77129dcdfe9d0$export$85bb3e53350e35b8(appearance, selectedNode, state.selection.$from.parent.type.name === 'bodiedSyncBlock') : $09c77129dcdfe9d0$export$85bb3e53350e35b8(appearance, selectedNode);
        const { from: from, to: to } = state.selection;
        const nodeType = $09c77129dcdfe9d0$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        // If switching to embed appearance, attempt to use a registered transform command
        // to create an alternative node representation (e.g. a native embed).
        if (appearance === 'embed' && (selectedNode.attrs.url || selectedNode.attrs.data?.url)) {
            const cardState = (0, $6SJAP.pluginKey).getState(state);
            const createEmbedCardTransformCommand = cardState?.embedCardTransformers?.createEmbedCardTransformCommand;
            if (createEmbedCardTransformCommand) {
                const transformCommand = createEmbedCardTransformCommand({
                    editorAnalyticsApi: editorAnalyticsApi,
                    augmentTransaction: (augmentTr)=>{
                        $09c77129dcdfe9d0$var$updateDatasourceStash(augmentTr, selectedNode);
                        editorAnalyticsApi?.attachAnalyticsEvent({
                            action: (0, $d925B.ACTION).CHANGED_TYPE,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            attributes: {
                                newType: appearance,
                                previousType: (0, $hrFA1.appearanceForNodeType)(selectedNode.type)
                            }
                        })(augmentTr);
                        (0, $doRn8.addLinkMetadata)(state.selection, augmentTr, {
                            action: (0, $d925B.ACTION).CHANGED_TYPE
                        });
                    }
                });
                if (transformCommand(state, dispatch)) return true;
            }
        }
        $09c77129dcdfe9d0$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).CHANGED_TYPE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $hrFA1.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $doRn8.addLinkMetadata)(state.selection, tr, {
            action: (0, $d925B.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $09c77129dcdfe9d0$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $09c77129dcdfe9d0$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: (0, $d925B.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $9AGwg.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $9AGwg.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $09c77129dcdfe9d0$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $9AGwg.hideDatasourceModal)(tr);
    (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: (0, $d925B.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $09c77129dcdfe9d0$export$85bb3e53350e35b8 = (appearance, selectedNode, isInsideBodiedSyncBlock = false)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center',
        ...isInsideBodiedSyncBlock ? // For editor, width is not required to render the embed card, but it's required in renderer
        // Because sync block has nested renderer in editor, we need width to be defined even in editor so embed in reference sync block can be rendered properly
        {
            width: selectedNode.attrs.width ?? 100
        } : {}
    };
    if ((0, $hrFA1.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $09c77129dcdfe9d0$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $hrFA1.isDatasourceNode)(selectedNode) && !(0, $hrFA1.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $9AGwg.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};
module.exports["replaceQueuedUrlWithCard"] = $09c77129dcdfe9d0$export$78f5a0da64579d3e;
module.exports["handleFallbackWithAnalytics"] = $09c77129dcdfe9d0$export$2bb01cc4a12e0b44;
module.exports["queueCardsFromChangedTr"] = $09c77129dcdfe9d0$export$f17c48478174211e;
module.exports["changeSelectedCardToLink"] = $09c77129dcdfe9d0$export$3f14f692ecc2a0d9;
module.exports["changeSelectedCardToLinkFallback"] = $09c77129dcdfe9d0$export$56a04318a610dc7c;
module.exports["updateCard"] = $09c77129dcdfe9d0$export$884fcee347ca969b;
module.exports["changeSelectedCardToText"] = $09c77129dcdfe9d0$export$23c9e012c8c1ce24;
module.exports["setSelectedCardAppearance"] = $09c77129dcdfe9d0$export$a188ef61ddbb94f;
module.exports["updateCardViaDatasource"] = $09c77129dcdfe9d0$export$113cdaf1b279f308;
module.exports["insertDatasource"] = $09c77129dcdfe9d0$export$7f7b236478a618df;

});

parcelRegister("22wcR", function(module, exports) {

var $6SJAP = parcelRequire("6SJAP");

const $58f6534fac2913cc$export$f05434c51e3762e = (editorState)=>(0, $6SJAP.pluginKey).getState(editorState);
const $58f6534fac2913cc$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $58f6534fac2913cc$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$58f6534fac2913cc$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $58f6534fac2913cc$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;
module.exports["getPluginState"] = $58f6534fac2913cc$export$f05434c51e3762e;
module.exports["getPluginStateWithUpdatedPos"] = $58f6534fac2913cc$export$be237c815d2927d4;
module.exports["getNewRequests"] = $58f6534fac2913cc$export$cd9326e2f6dc42c0;

});

parcelRegister("aLPDZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $d27fb1bdf94e43d0$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $eIleF.useSmartCardContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children(cardContext)
    });
};
module.exports["WithCardContext"] = $d27fb1bdf94e43d0$export$722ea04dd4ef208e;

});

parcelRegister("6SJAP", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $0919fa9d22307ea8$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('cardPlugin');
module.exports["pluginKey"] = $0919fa9d22307ea8$export$18d4026d1ea86bb1;

});

parcelRegister("5v798", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");

const $76789ce241129de5$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $76789ce241129de5$export$4521957a9ae858f5 = 'discovered';
const $76789ce241129de5$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $76789ce241129de5$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $76789ce241129de5$export$2cf27d95188f1c13 = 86400000;
const $76789ce241129de5$var$storageClient = new (0, $kt8c2.default)($76789ce241129de5$export$c0fd7e3ed450d078);
const $76789ce241129de5$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $76789ce241129de5$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $76789ce241129de5$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $76789ce241129de5$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $76789ce241129de5$var$storageClient.setItemWithExpiry(key, $76789ce241129de5$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};
module.exports["LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK"] = $76789ce241129de5$export$613f4cbb1d6327d6;
module.exports["LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR"] = $76789ce241129de5$export$b1ab83c904a5352e;
module.exports["ONE_DAY_IN_MILLISECONDS"] = $76789ce241129de5$export$2cf27d95188f1c13;
module.exports["isLocalStorageKeyDiscovered"] = $76789ce241129de5$export$f029a1bf9ca298da;
module.exports["markLocalStorageKeyDiscovered"] = $76789ce241129de5$export$6b9d1ae5ec92c88e;

});

parcelRegister("jqKkl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7dJ3M = parcelRequire("7dJ3M");


var $5v798 = parcelRequire("5v798");

const $e765d4b609cfc3b8$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $5v798.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $42omo.useCallback)(()=>{
        if (!discovered) (0, $5v798.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7dJ3M.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};
module.exports["DiscoveryPulse"] = $e765d4b609cfc3b8$export$1f5748a1623673d7;

});

parcelRegister("0vvte", function(module, exports) {
const $c37b3947c7842800$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $c37b3947c7842800$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
module.exports["DATASOURCE_INNER_CONTAINER_CLASSNAME"] = $c37b3947c7842800$export$32f80df830e375f6;
module.exports["FLOATING_TOOLBAR_LINKPICKER_CLASSNAME"] = $c37b3947c7842800$export$863ae87a9d233606;

});

parcelRegister("dQwlz", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");


var $fBAKC = parcelRequire("fBAKC");


var $btzjy = parcelRequire("btzjy");

class $0f57150f8f286408$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $81OAa.isSafeUrl)(url)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fBAKC.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $btzjy.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $l998X.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $fBAKC.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isError: false,
            error: null
        };
    }
}
module.exports["DatasourceErrorBoundary"] = $0f57150f8f286408$export$76664c71b9b1a689;

});

parcelRegister("aJdNi", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $lWghV = parcelRequire("lWghV");


var $22wcR = parcelRequire("22wcR");

const $00b58e153814f38c$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $22wcR.getPluginState)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $lWghV.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: analyticsData,
        children: children
    });
};
module.exports["EditorAnalyticsContext"] = $00b58e153814f38c$export$b49e513cc101a4b6;

});

parcelRegister("cOfDZ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");


var $bYRk6 = parcelRequire("bYRk6");


var $eiA8Z = parcelRequire("eiA8Z");


var $lWghV = parcelRequire("lWghV");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $btzjy = parcelRequire("btzjy");


var $22wcR = parcelRequire("22wcR");


var $hrFA1 = parcelRequire("hrFA1");


var $aLPDZ = parcelRequire("aLPDZ");

const $c4e66116155c2679$var$fatalErrorPositionMap = new Map();
const $c4e66116155c2679$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children })=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>{
        return {
            mode: states.editorViewModeState?.mode
        };
    });
    const onClick = (0, $42omo.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $c4e66116155c2679$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $hrFA1.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $81OAa.isSafeUrl)(url)) return /*#__PURE__*/ (0, $l998X.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__linking-platfo') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: url,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $l998X.jsx)("a", {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $l998X.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (0, $22wcR.getPluginState)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $lWghV.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)($c4e66116155c2679$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aLPDZ.WithCardContext), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $l998X.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $hrFA1.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                const pos = getPos();
                /**
         * We cache fatal errors by position to avoid retrying the same errors
         * on the same links at the same position.
         */ if (url && pos && $c4e66116155c2679$var$fatalErrorPositionMap.get(url) === pos) return null;
                (0, $btzjy.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                if (url && pos) $c4e66116155c2679$var$fatalErrorPositionMap.set(url, pos);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isError: false
            };
        }
    };
}
module.exports["Card"] = $c4e66116155c2679$export$60332b2344f7fe41;

});

parcelRegister("9QE25", function(module, exports) {
"use strict";
var $72b8060db0128555$var$__assign = module.exports && module.exports.__assign || function() {
    $72b8060db0128555$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72b8060db0128555$var$__assign.apply(this, arguments);
};
var $72b8060db0128555$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $72b8060db0128555$var$React = $72b8060db0128555$var$__importStar((parcelRequire("42omo")));
var $72b8060db0128555$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $72b8060db0128555$var$Resizer(props) {
    return $72b8060db0128555$var$React.createElement("div", {
        className: props.className || '',
        style: $72b8060db0128555$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $72b8060db0128555$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $72b8060db0128555$var$Resizer;

});

parcelRegister("kXd3n", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $3RxtY = parcelRequire("3RxtY");


var $3P0Cg = parcelRequire("3P0Cg");


var $16GCc = parcelRequire("16GCc");


var $ks2lK = parcelRequire("ks2lK");


var $4Z0ju = parcelRequire("4Z0ju");


var $eIleF = parcelRequire("eIleF");


var $1s5hv = parcelRequire("1s5hv");


var $btzjy = parcelRequire("btzjy");


var $6SJAP = parcelRequire("6SJAP");


var $kAODm = parcelRequire("kAODm");


var $8dcLZ = parcelRequire("8dcLZ");

function $151e83dc333d8b97$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $151e83dc333d8b97$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $151e83dc333d8b97$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $42omo.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $6SJAP.pluginKey).getState(editorState);
        const newAdf = (0, $4Z0ju.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $ks2lK.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $btzjy.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $16GCc.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
        css: $151e83dc333d8b97$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kAODm.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button',
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
};
const $151e83dc333d8b97$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)($151e83dc333d8b97$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["DatasourceAppearanceButton"] = $151e83dc333d8b97$export$76de8066d79563a4;

});

parcelRegister("8eb8d", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");

var $iGbqR = parcelRequire("iGbqR");


var $doRn8 = parcelRequire("doRn8");


var $6YpFi = parcelRequire("6YpFi");


var $ckqYV = parcelRequire("ckqYV");


var $9fPrY = parcelRequire("9fPrY");


var $ks2lK = parcelRequire("ks2lK");


var $9AGwg = parcelRequire("9AGwg");


var $btzjy = parcelRequire("btzjy");


var $hrFA1 = parcelRequire("hrFA1");

function $0f3dd242ddf2d35f$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6YpFi.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $0f3dd242ddf2d35f$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $9AGwg.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)($0f3dd242ddf2d35f$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $9AGwg.hideLinkToolbar)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $ckqYV.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $0f3dd242ddf2d35f$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $9AGwg.showLinkToolbar)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $0f3dd242ddf2d35f$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $hrFA1.displayInfoForCard)(node, (0, $hrFA1.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, $l998X.jsx)($0f3dd242ddf2d35f$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $d925B.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $btzjy.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $0f3dd242ddf2d35f$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker)=>{
    return showLinkingToolbar ? {
        height: lpLinkPicker ? (0, $9fPrY.LINKPICKER_HEIGHT_IN_PX) : (0, $9fPrY.RECENT_SEARCH_HEIGHT_IN_PX),
        width: (0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX),
        forcePlacement: true
    } : {};
};
module.exports["getEditLinkCallback"] = $0f3dd242ddf2d35f$export$c389e1daeae312a9;
module.exports["buildEditLinkToolbar"] = $0f3dd242ddf2d35f$export$dec3901e38d4e7ff;
module.exports["editLinkToolbarConfig"] = $0f3dd242ddf2d35f$export$acaefd190fd8ff4d;

});

parcelRegister("fezbA", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $hiS1z = parcelRequire("hiS1z");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");


var $eIleF = parcelRequire("eIleF");


var $56M4r = parcelRequire("56M4r");


var $1s5hv = parcelRequire("1s5hv");


var $iu6m9 = parcelRequire("iu6m9");


var $hrFA1 = parcelRequire("hrFA1");


var $bzmKd = parcelRequire("bzmKd");


var $i88u2 = parcelRequire("i88u2");


var $8dcLZ = parcelRequire("8dcLZ");


var $ihjbA = parcelRequire("ihjbA");

const $7ef92b1c6084c116$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $7ef92b1c6084c116$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, ...response } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $42omo.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $42omo.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $hrFA1.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $42omo.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $bzmKd.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-link",
                onClick: onEditLink,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $ckqYV.linkToolbarMessages).editLink)), !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $ckqYV.linkToolbarMessages).editDatasourceStandalone)), !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                        css: $7ef92b1c6084c116$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: intl.formatMessage((0, $3RxtY.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $3RxtY.messages).editDropdownTriggerTitle)), !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2dkHo.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $3RxtY.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $3RxtY.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $7ef92b1c6084c116$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $42omo.useMemo)(()=>{
        if (!datasourceId || !(0, $hrFA1.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ihjbA.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $7ef92b1c6084c116$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const fetchData = (0, $42omo.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $i88u2.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $42omo.useMemo)(()=>{
        if (!datasourceId || !(0, $hrFA1.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ihjbA.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $7ef92b1c6084c116$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $9K4OG.jsx)($7ef92b1c6084c116$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $9K4OG.jsx)($7ef92b1c6084c116$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)($7ef92b1c6084c116$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["EditToolbarButton"] = $7ef92b1c6084c116$export$4f24788e7d04736b;

});

parcelRegister("iDVNw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $iHzeA = parcelRequire("iHzeA");


var $faH35 = parcelRequire("faH35");


var $1s5hv = parcelRequire("1s5hv");


var $kXd3n = parcelRequire("kXd3n");


var $dzW6s = parcelRequire("dzW6s");

function $40a4b0a86667e298$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $42omo.useState)(new Map());
    const cardProvider = (0, $42omo.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $42omo.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dzW6s.LinkToolbarAppearance), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions?.allowEmbeds,
                allowBlockCards: cardOptions?.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, "link-appearance"),
            cardOptions?.allowDatasource && /*#__PURE__*/ (0, $l998X.jsx)((0, $kXd3n.DatasourceAppearanceButton), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        ]
    });
}
module.exports["HyperlinkToolbarAppearance"] = $40a4b0a86667e298$export$33d351e602b13f5c;

});

parcelRegister("iVRHt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cPDAt = parcelRequire("cPDAt");


var $iHzeA = parcelRequire("iHzeA");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");


var $1s5hv = parcelRequire("1s5hv");


var $lB6pw = parcelRequire("lB6pw");

const $f704836bc583e15c$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $42omo.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const cardProvider = (0, $42omo.useRef)(undefined);
    const containerRef = (0, $42omo.useRef)(undefined);
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            // eslint-disable-line no-unused-vars
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $42omo.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $cPDAt.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $l998X.jsx)((0, $3P0Cg.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: title
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2dkHo.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                arrowKeyNavigationProviderOptions: {
                    type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lB6pw.LinkAppearanceMenu), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions?.allowEmbeds,
                    allowBlockCards: cardOptions?.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                })
            }),
            !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar))
            })
        ]
    });
};
const $f704836bc583e15c$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $l998X.jsx)($f704836bc583e15c$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};
module.exports["getCustomHyperlinkAppearanceDropdown"] = $f704836bc583e15c$export$5b48c4cfa5ad82e1;

});

parcelRegister("dzW6s", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $d925B = parcelRequire("d925B");


var $doRn8 = parcelRequire("doRn8");

var $cPDAt = parcelRequire("cPDAt");

var $eyrsK = parcelRequire("eyrsK");


var $3RxtY = parcelRequire("3RxtY");

var $61p3e = parcelRequire("61p3e");


var $7iE7T = parcelRequire("7iE7T");


var $5SAOw = parcelRequire("5SAOw");


var $btzjy = parcelRequire("btzjy");


var $hrFA1 = parcelRequire("hrFA1");


var $5v798 = parcelRequire("5v798");


var $jqKkl = parcelRequire("jqKkl");


var $9Rg2N = parcelRequire("9Rg2N");


var $aLPDZ = parcelRequire("aLPDZ");

class $e7d0a15e1573e816$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $aLPDZ.WithCardContext), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args);
        this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $3RxtY.messages).embed),
                onClick: (0, $btzjy.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $e7d0a15e1573e816$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $3RxtY.messages).block),
                onClick: (0, $btzjy.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $e7d0a15e1573e816$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $3RxtY.messages).url),
                    onClick: (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $d925B.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $3RxtY.messages).inline),
                    onClick: (0, $btzjy.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $l998X.jsx)((0, $eyrsK.LinkToolbarButtonGroup), {
                options: options.map((option)=>(0, $cPDAt.getButtonGroupOption)(intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, {
                        ...option,
                        onClick: (0, $doRn8.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $9Rg2N.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $hrFA1.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jqKkl.DiscoveryPulse), {
                        localStorageKey: (0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                }));
            }
            return LinkToolbarButtons;
        };
    }
}
const $e7d0a15e1573e816$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $61p3e.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $3RxtY.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        return intl.formatMessage((0, $3RxtY.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $61p3e.default).defaultBlockNode)
        });
    }
};
module.exports["LinkToolbarAppearance"] = $e7d0a15e1573e816$export$2a8c6fb42753b13e;
module.exports["getUnavailableMessage"] = $e7d0a15e1573e816$export$74e77d31eb18de27;

});

parcelRegister("lB6pw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $cPDAt = parcelRequire("cPDAt");

var $doRn8 = parcelRequire("doRn8");

var $72Ahd = parcelRequire("72Ahd");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $7iE7T = parcelRequire("7iE7T");


var $5SAOw = parcelRequire("5SAOw");


var $eIleF = parcelRequire("eIleF");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $iu6m9 = parcelRequire("iu6m9");


var $btzjy = parcelRequire("btzjy");


var $h8aIC = parcelRequire("h8aIC");


var $dzW6s = parcelRequire("dzW6s");

const $e531789fa6ee47a1$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $eIleF.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $3RxtY.messages).embed),
        onClick: (0, $btzjy.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $dzW6s.getUnavailableMessage)(editorState, intl),
        description: (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? intl.formatMessage((0, $3RxtY.messages).embedToBlockCardWarning) : undefined
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $3RxtY.messages).block),
        onClick: (0, $btzjy.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $dzW6s.getUnavailableMessage)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $3RxtY.messages).url),
            onClick: (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $d925B.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $3RxtY.messages).inline),
            onClick: (0, $btzjy.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $72Ahd.getDropdownOption)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $doRn8.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2SlZp.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                            iconBefore: option.icon,
                            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            description: option.description,
                            shouldDescriptionWrap: true,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $h8aIC.DatasourceDropdownOption), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            'href' in settingsConfig && settingsConfig.href && /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: settingsConfig.href,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $ckqYV.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $e531789fa6ee47a1$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($e531789fa6ee47a1$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $h8aIC.datasourceDisplayInformation) : (0, $cPDAt.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};
module.exports["LinkAppearanceMenu"] = $e531789fa6ee47a1$export$6ce0ca681c51cdfb;
module.exports["getLinkAppearanceDropdown"] = $e531789fa6ee47a1$export$1faf5b64d0bbe935;

});

parcelRegister("l1M3D", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $fpEzC = parcelRequire("fpEzC");


var $3P0Cg = parcelRequire("3P0Cg");


var $jypE9 = parcelRequire("jypE9");


var $79vw2 = parcelRequire("79vw2");


var $eIleF = parcelRequire("eIleF");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $226XV = parcelRequire("226XV");


var $1oCLl = parcelRequire("1oCLl");


var $hrFA1 = parcelRequire("hrFA1");


var $5YZhQ = parcelRequire("5YZhQ");

const $54948e9cec84ca0f$export$9ed3225219cdbbe9 = ({ node: node, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView })=>{
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const url = node.attrs.url;
    const display = (0, $5YZhQ.appearanceForLink)(node);
    const cardState = store?.getState()[url];
    if (cardState) {
        const ari = (0, $226XV.getObjectAri)(cardState.details);
        const name = (0, $226XV.getObjectName)(cardState.details);
        const iconUrl = (0, $226XV.getObjectIconUrl)(cardState.details);
        const isPanelAvailable = ari && isPreviewPanelAvailable?.({
            ari: ari
        });
        const handleOpenGlancePanelClick = ()=>{
            if (openPreviewPanel && isPanelAvailable) openPreviewPanel({
                url: url,
                ari: ari,
                name: name || '',
                iconUrl: iconUrl,
                panelData: {
                    embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $79vw2.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                }
            });
            editorAnalyticsApi?.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TOOLBAR_PREVIEW,
                attributes: {
                    previewType: 'panel',
                    ...(0, $hrFA1.getResolvedAttributesFromStore)(url, display, store)
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
        };
        const title = intl.formatMessage((0, $fpEzC.linkMessages).openPreviewPanel);
        const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
            label: "",
            spacing: "spacious"
        }) : // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
        // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            as: "span",
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
                    label: "",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                })
            ]
        });
        if (openPreviewPanel && isPanelAvailable) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            gap: "space.050",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3P0Cg.default), {
                testId: "open-preview-panel-floating-toolbar-button",
                onClick: handleOpenGlancePanelClick,
                icon: icon,
                title: title,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        });
    }
    return null;
};
module.exports["OpenPreviewPanelToolbarButton"] = $54948e9cec84ca0f$export$9ed3225219cdbbe9;

});

parcelRegister("hh4Zj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $9AGwg = parcelRequire("9AGwg");


var $22wcR = parcelRequire("22wcR");


var $hrFA1 = parcelRequire("hrFA1");


var $aJdNi = parcelRequire("aJdNi");

const $846dee625ed88da2$var$areResolvedAttributesEqual = (current, next)=>current?.displayCategory === next?.displayCategory && current?.extensionKey === next?.extensionKey && current?.status === next?.status && current?.statusDetails === next?.statusDetails;
/**
 * Handles firing the toolbar viewed event
 */ const $846dee625ed88da2$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext, editorView: editorView })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $42omo.useEffect)(()=>{
        const resolvedAttributes = (0, $hrFA1.getResolvedAttributesFromStore)(url, display, store);
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...resolvedAttributes,
                display: display
            }
        }).fire('media');
        if (!editorView) return;
        const currentResolvedAttributes = (0, $22wcR.getPluginState)(editorView.state)?.resolvedToolbarAttributesByUrl[url];
        if ($846dee625ed88da2$var$areResolvedAttributesEqual(currentResolvedAttributes, resolvedAttributes)) return;
        editorView.dispatch((0, $9AGwg.setResolvedToolbarAttributes)(url, resolvedAttributes)(editorView.state.tr));
    }, [
        createAnalyticsEvent,
        display,
        editorView,
        url,
        store
    ]);
    return null;
};
const $846dee625ed88da2$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aJdNi.EditorAnalyticsContext), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $l998X.jsx)($846dee625ed88da2$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext,
            editorView: editorView
        }) : null
    });
};
module.exports["ToolbarViewedEvent"] = $846dee625ed88da2$export$998ac2a59a1547dd;

});

parcelRegister("1yFQS", function(module, exports) {

var $81OAa = parcelRequire("81OAa");


var $jvA0K = parcelRequire("jvA0K");

function $f05144695fcb9350$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $81OAa.normalizeUrl)((0, $jvA0K.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $81OAa.normalizeUrl)((0, $jvA0K.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $81OAa.normalizeUrl)((0, $jvA0K.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}
module.exports["shouldReplaceLink"] = $f05144695fcb9350$export$f85e921f66e987fa;

});

parcelRegister("7dJ3M", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $20b7533ed055ad0f$var$pulseKeyframes = null;
const $20b7533ed055ad0f$var$pulseStyles = null;
const $20b7533ed055ad0f$var$commonStyles = null;
const $20b7533ed055ad0f$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $42omo.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $gMc0m.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rkofajl _16qs1l47 _j7hq8j16 _5sagw34l _1pgl1trn _tip811wp"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation,
            children: children
        })
    });
};
var $20b7533ed055ad0f$export$2e2bcd8739ae039 = $20b7533ed055ad0f$export$927d63e2511364c0;
module.exports["Pulse"] = $20b7533ed055ad0f$export$927d63e2511364c0;

});

parcelRegister("kAODm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2g1PW = parcelRequire("2g1PW");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $494cc9c19b2fcab3$var$wrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $494cc9c19b2fcab3$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
        xcss: $494cc9c19b2fcab3$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))), {
            label: props?.label
        })
    });
};
module.exports["DatasourceIcon"] = $494cc9c19b2fcab3$export$8819453811a57211;

});

parcelRegister("8dcLZ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");

const $8cceaee26ea01a76$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $42omo.useState)(undefined);
    const [parameters, setParameters] = (0, $42omo.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $42omo.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};
module.exports["useFetchDatasourceInfo"] = $8cceaee26ea01a76$export$d01c44dffc996c80;

});

parcelRegister("bzmKd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $16GCc = parcelRequire("16GCc");


var $9AGwg = parcelRequire("9AGwg");

const $6c6198ca60f9b061$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $16GCc.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $9AGwg.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };
module.exports["editDatasource"] = $6c6198ca60f9b061$export$687401cc190b9ec3;

});

parcelRegister("i88u2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $655oj = parcelRequire("655oj");

const $3889f3bf0db7cc75$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $42omo.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $655oj.useDatasourceClientExtension)();
    (0, $42omo.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $655oj.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};
module.exports["useFetchDatasourceDataInfo"] = $3889f3bf0db7cc75$export$25222ec28f4cbba5;

});

parcelRegister("ihjbA", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $hiS1z = parcelRequire("hiS1z");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");


var $1Zr9M = parcelRequire("1Zr9M");


var $56M4r = parcelRequire("56M4r");


var $1s5hv = parcelRequire("1s5hv");


var $hrFA1 = parcelRequire("hrFA1");


var $bzmKd = parcelRequire("bzmKd");

const $46168b6b87dd0065$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $46168b6b87dd0065$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $42omo.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $42omo.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $bzmKd.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: ""
    }) : undefined;
    const tooltipContent = areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                tooltipContent: tooltipContent,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $ckqYV.linkToolbarMessages).editLink)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $ckqYV.linkToolbarMessages).editDatasourceStandalone)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                        css: $46168b6b87dd0065$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: intl.formatMessage((0, $3RxtY.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $3RxtY.messages).editDropdownTriggerTitle)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2dkHo.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $3RxtY.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hiS1z.default), (0, $3RxtY.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $46168b6b87dd0065$export$2e2bcd8739ae039 = $46168b6b87dd0065$var$EditToolbarButtonPresentation;
module.exports["default"] = $46168b6b87dd0065$export$2e2bcd8739ae039;

});

parcelRegister("cPDAt", function(module, exports) {

var $5Yp2m = parcelRequire("5Yp2m");


var $65WMN = parcelRequire("65WMN");


var $99wB5 = parcelRequire("99wB5");


var $erzkB = parcelRequire("erzkB");


var $3RxtY = parcelRequire("3RxtY");

const $6055067c9b32987f$export$b5524c7a5a82630a = {
    url: {
        title: (0, $3RxtY.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m)))
    },
    inline: {
        title: (0, $3RxtY.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($erzkB)))
    },
    block: {
        title: (0, $3RxtY.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($65WMN)))
    },
    embed: {
        title: (0, $3RxtY.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($99wB5)))
    }
};
const $6055067c9b32987f$export$9de0d67eaa25f178 = (intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = $6055067c9b32987f$export$b5524c7a5a82630a[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    };
};
module.exports["appearancePropsMap"] = $6055067c9b32987f$export$b5524c7a5a82630a;
module.exports["getButtonGroupOption"] = $6055067c9b32987f$export$9de0d67eaa25f178;

});

parcelRegister("eyrsK", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $hArLp = parcelRequire("hArLp");


var $3P0Cg = parcelRequire("3P0Cg");

function $ae8d85fab1bee39d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $ae8d85fab1bee39d$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $ae8d85fab1bee39d$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $ae8d85fab1bee39d$var$DisallowedWrapper = ({ disabled: disabled, children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: disabled ? $ae8d85fab1bee39d$var$disallowedWrapperStyle : $ae8d85fab1bee39d$var$defaultWrapperStyle
    }, children);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $ae8d85fab1bee39d$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $ae8d85fab1bee39d$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $ae8d85fab1bee39d$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $9K4OG.jsx)($ae8d85fab1bee39d$var$DisallowedWrapper, {
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            css: disabled ? $ae8d85fab1bee39d$var$buttonStyleNoneEvent : $ae8d85fab1bee39d$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious"
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }));
};
module.exports["LinkToolbarButtonGroup"] = $ae8d85fab1bee39d$export$41ba5f90e13b0c51;

});

parcelRegister("72Ahd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cPDAt = parcelRequire("cPDAt");

const $b76944e9413775bf$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip, description: description })=>{
    const { title: title, icon: Icon } = (0, $cPDAt.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? '',
        description: description
    };
};
module.exports["getDropdownOption"] = $b76944e9413775bf$export$1405b80fcb4301ca;

});

parcelRegister("h8aIC", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3RxtY = parcelRequire("3RxtY");


var $ks2lK = parcelRequire("ks2lK");


var $2g1PW = parcelRequire("2g1PW");


var $4Z0ju = parcelRequire("4Z0ju");


var $eIleF = parcelRequire("eIleF");


var $56M4r = parcelRequire("56M4r");


var $btzjy = parcelRequire("btzjy");


var $6SJAP = parcelRequire("6SJAP");


var $8dcLZ = parcelRequire("8dcLZ");

const $f18919f30179225a$export$12f82ee4a2a1a1c9 = {
    title: (0, $3RxtY.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW)))
};
const $f18919f30179225a$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $6SJAP.pluginKey).getState(editorState);
        const newAdf = (0, $4Z0ju.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $ks2lK.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $btzjy.updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW)))({
            label: intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle)
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle));
};
module.exports["datasourceDisplayInformation"] = $f18919f30179225a$export$12f82ee4a2a1a1c9;
module.exports["DatasourceDropdownOption"] = $f18919f30179225a$export$b08a863b9d82986d;

});

parcelRegister("5YZhQ", function(module, exports) {

var $hrFA1 = parcelRequire("hrFA1");


var $h92Fd = parcelRequire("h92Fd");

function $71bdcf3b71e7ffc8$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $71bdcf3b71e7ffc8$export$26ada819291bd8df = (node)=>{
    if ($71bdcf3b71e7ffc8$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $hrFA1.appearanceForNodeType)(node.type)) return true;
    return $71bdcf3b71e7ffc8$var$hasLinkMark(node);
};
function $71bdcf3b71e7ffc8$export$d3d4c2526aede29a(node) {
    if ($71bdcf3b71e7ffc8$export$962cfe99b8da8614(node)) return (0, $h92Fd.EVENT_SUBJECT).DATASOURCE;
    if ($71bdcf3b71e7ffc8$export$26ada819291bd8df(node)) return (0, $h92Fd.EVENT_SUBJECT).LINK;
    return null;
}
function $71bdcf3b71e7ffc8$export$599e1b655555ab1d(node) {
    const appearance = (0, $hrFA1.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $71bdcf3b71e7ffc8$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $71bdcf3b71e7ffc8$var$hasLinkMark = (node)=>{
    return !!$71bdcf3b71e7ffc8$var$getLinkMark(node);
};
function $71bdcf3b71e7ffc8$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $71bdcf3b71e7ffc8$var$getLinkMark(node)?.attrs?.href;
}
const $71bdcf3b71e7ffc8$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $71bdcf3b71e7ffc8$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $71bdcf3b71e7ffc8$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $71bdcf3b71e7ffc8$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $71bdcf3b71e7ffc8$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $71bdcf3b71e7ffc8$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($71bdcf3b71e7ffc8$export$94df0e59ebebf4a7(a.node) !== $71bdcf3b71e7ffc8$export$94df0e59ebebf4a7(b.node) || $71bdcf3b71e7ffc8$export$599e1b655555ab1d(a.node) !== $71bdcf3b71e7ffc8$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};
module.exports["getNodeSubject"] = $71bdcf3b71e7ffc8$export$d3d4c2526aede29a;
module.exports["appearanceForLink"] = $71bdcf3b71e7ffc8$export$599e1b655555ab1d;
module.exports["getUrl"] = $71bdcf3b71e7ffc8$export$94df0e59ebebf4a7;
module.exports["getNodeContext"] = $71bdcf3b71e7ffc8$export$c63a892fcfc539bc;
module.exports["findAtPositions"] = $71bdcf3b71e7ffc8$export$7ea2145b3909e5c6;
module.exports["findInNodeRange"] = $71bdcf3b71e7ffc8$export$dbc52ec0d340ce50;
module.exports["areSameNodes"] = $71bdcf3b71e7ffc8$export$1f3592a520a7960d;

});

parcelRegister("h92Fd", function(module, exports) {
var $296e6e32869f313c$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $296e6e32869f313c$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});
module.exports["EVENT"] = $296e6e32869f313c$export$e39a34cfd532e15;
module.exports["EVENT_SUBJECT"] = $296e6e32869f313c$export$97c6cb64ce06a88a;

});


$parcel$global.rlb("gUo8V")
//# sourceMappingURL=FullPageEditorComponent.92243805.js.map
